import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Renderer2,
  ElementRef,
  ViewChild,
  AfterViewChecked,
  AfterViewInit,
} from "@angular/core";
import { FormioModule } from "@formio/angular";
import { FormioGrid } from "@formio/angular/grid";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { Formio } from "@formio/angular";
import premium from "@formio/premium";
import { firstValueFrom, Subscription } from "rxjs";
import { HttpClientModule } from "@angular/common/http";
import { ChangeDetectorRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { environment } from "../../../../../environments/environment";
import { LoadingService } from "../../../../core/services/loading.service";
import { BreadcrumbComponent } from "../../../../shared/components/breadcrumb/breadcrumb.component";
import { PatientService } from "../../../../core/services/patient.service";
import { AuthService } from "../../../../core/services/auth.service";
import {
	LayoutRemap,
	PI_CONSENT_PDF,
	unbrandedConsentPdfUrl,
	unbrandedSignatureHeight,
	unbrandedTemplateLayout,
	unbrandedTemplatePath,
	WC_FORMS_PDF,
} from "../../../../core/services/unbranded-forms.util";
import { TabTrackingService } from "../../../../core/services/tabtracking.service";
import { HttpClient } from "@angular/common/http";
import {  PdfViewerModule } from "ng2-pdf-viewer";
import fontkit from '@pdf-lib/fontkit';
import {
  PDFDocument,
  rgb,
  StandardFonts,
} from "pdf-lib";
import { SignaturePDFService } from "../../../../core/services/signature-pdf.service";
import SignaturePad from "signature_pad";
import { ABNForm } from "../../models/abn-form.model";
import { TabDictionary } from "../../models/tab-form.model";
import { TabEnum } from "../../../../core/enums/tab-enum";
import { HeaderIntake } from "../../models/header-intake.model";
import { FileUploadService } from "../../../../core/services/file-upload.service";
import { buildDownloadFileName } from "../../../../core/services/download-name.util";
import {
	AutosaveState,
	FormAutosaveService,
} from "../../../../core/services/form-autosave.service";

// qa branch with all dev changes and curve/waystar changes
// Ensure Formio is configured
Formio.license = environment.LICENSE;
Formio.use(premium);
Formio.setBaseUrl(environment.BASE_URL);
Formio.setProjectUrl(environment.PROJECT_URL);

// "Is the patient covered by Insurance?" values that do not get a Curve record
const CURVE_EXCLUDED_INSURANCES = [
	"None/Selfpay",
	"Automobile (Motor Vehicle Accident ONLY)",
	"Workers Comp (Injury During Work ONLY)",
	"Veterans Administration(VA)",
];

@Component({
	selector: "app-new-intake",
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		FormioGrid,
		FormioModule,
		HttpClientModule,
		BreadcrumbComponent,
		PdfViewerModule,
	],
	templateUrl: "./new-intake.component.html",
	styleUrls: ["./new-intake.component.css"],
})
export class NewIntakeComponent implements OnInit, OnDestroy {
	submissionId: string | null = null;
	formData: any = null;
	form: any = null;
	token: string | null = null;
	isLoading: boolean = true;
	isReadOnly: boolean = false;
	patientName: string = "";
	downloadError: string | null = null;
	downloadMessage: string | null = null;
	readingMode: boolean = false;
	//added for locking the user
	isLockedByOtherUser: boolean = false;
	lockedByUser: string = "";
	lockedByDate: any = null;

	//added for tab tracking
	isOpenInAnotherTab: boolean = false;
	otherTabOpenTime: string = "";
	private tabInstanceId: string = '';
	private initialLockDateTime: string | null = null;

	// Fingerprint of the server copy as this tab loaded it
	// All three come from the server, so they are compared for inequality
	// Refreshed after our own writes, so "changed" means someone else
	private initialLastUnlockDateTime: string | null = null;
	private knownModified: string | null = null;
	private knownAutosavedAt: string | null = null;
	private isTakingOver: boolean = false;
	private manualSaveInProgress: boolean = false;
	formTakenOver: boolean = false;
	formTakenOverBy: string = '';
	private storageListener: ((event: StorageEvent) => void) | null = null;

	// Keep track if form was submitted successfully
	formSubmitted: boolean = false;

	// Autosave state, armed after the form finishes hydrating
	autosaveState: AutosaveState = { status: "idle", lastSavedAt: null, message: null };
	private autosaveArmed: boolean = false;
	private autosaveSub?: Subscription;

	availableForms: Array<{
		name: string;
		formId: string;
		submissionId: string;
	}> = [];
	availableTabs: Array<string> = ["Intake-Form"];

	private routeSub?: Subscription;
	private clearButtonObserver?: MutationObserver;
	private enterCheckboxHandler?: (e: KeyboardEvent) => void;
	private pdfDoc: PDFDocument | null = null;
	private pdfDocDownload: PDFDocument | null = null;
	pdfSrc: Uint8Array | null = null;
	pdfBytes: Uint8Array | null = null;
	pdfBytesSnapshot: Uint8Array | null = null;

	pdfSrcAA: Uint8Array | null = null;
	pdfBytesAA: Uint8Array | null = null;
	pdfBytesAASnapshot: Uint8Array | null = null;

	pdfSrcCCOF: Uint8Array | null = null;
	pdfBytesCCOF: Uint8Array | null = null;
	pdfBytesCCOFSnapshot: Uint8Array | null = null;

	pdfSrcNOPP: Uint8Array | null = null;
	pdfBytesNOPP: Uint8Array | null = null;
	pdfBytesNOPPSnapshot: Uint8Array | null = null;

	pdfABNSrc: Uint8Array | null = null;
	pdfABNBytes: Uint8Array | null = null;
	pdfABNBytesDownLoad: Uint8Array | null = null;
	pdfTextSrc: Uint8Array | null = null;
	pdfTextBytes: Uint8Array | null = null;
	pdfTextBytesSnapshot: Uint8Array | null = null;

	pdfScribeSrc: Uint8Array | null = null;
	pdfScribeBytes: Uint8Array | null = null;
	pdfScribeBytesSnapshot: Uint8Array | null = null;

	mergedConsentPdfSrc: Uint8Array | null = null;

	private _showAATab: boolean = false;
	private _showCCOF: boolean = false;
	private _showScribe: boolean = false;

	private _showABNForm: boolean = false;
	private _showInformedConsentTab: boolean = false;
	private _showTextConsentTab: boolean = false;
	previousStates: boolean[] = [];
	signatureDate: string | null = null;
	firstLoad = true;
	private savedFormHtml: string | null = null;
	private headerIntake: HeaderIntake | undefined;
	private savedStyles: string = "";

	private _fontBytes: ArrayBuffer | null = null;

	tabs: TabDictionary = {
		[TabEnum.IntakeForm]: {
			displayName: "Intake",
			order: 1,
			suffix: "-Intake-Form",
			visible: true,
			downloadable: true,
		},
		[TabEnum.ABN]: {
			displayName: "ABN",
			order: 2,
			suffix: "-ABN-Form",
			visible: false,
			downloadable: false,
		},
		[TabEnum.InformedConsent]: {
			displayName: "Informed Consent",
			order: 3,
			suffix: "-Informed-Consent",
			visible: false,
			downloadable: false,
		},
		[TabEnum.PaymentAgreements]: {
			displayName: "Payment A & A",
			order: 4,
			suffix: "-Agreements-Authorizations",
			visible: false,
			downloadable: false,
		},
		[TabEnum.CommunicationsConsent]: {
			displayName: "Communications Consent",
			order: 5,
			suffix: "-Communications-Consent",
			visible: false,
			downloadable: false,
		},
		[TabEnum.CCOF]: {
			displayName: "Credit Card On File",
			order: 6,
			suffix: "-Credit-Card-On-File",
			visible: false,
			downloadable: false,
		},
		[TabEnum.ReceiptOfNOPP]: {
			displayName: "Receipt of NOPP",
			order: 7,
			suffix: "-Receipt-Of-NOPP",
			visible: false,
			downloadable: false,
		},
		[TabEnum.PITemplate]: {
			displayName: "PI",
			order: 8,
			suffix: "-PI-Form",
			visible: false,
			downloadable: false,
		},
		[TabEnum.Scribe]: {
			displayName: "Scribe",
			order: 9,
			suffix: "-Scribe-Form",
			visible: false,
			downloadable: false,
		}
	};
	abnForm: ABNForm = {};
	showSignatureModal = false;
	@ViewChild("signatureCanvas", { static: false }) signatureCanvas!: ElementRef<HTMLCanvasElement>;
	signaturePad!: SignaturePad;

	// PI template state
	pdfPISrc: Uint8Array | null = null;
	pdfPIBytes: Uint8Array | null = null;
	pdfPIBytesSnapshot: Uint8Array | null = null;
	pdfPIDoc: PDFDocument | null = null;

	// Insurance image URLs at the moment the form was loaded — used to detect
	// adds/replacements made in the Clinic App so we know whether to queue a
	// new request to the API on save.
	private initialInsuranceImages: {
		primaryFront: string;
		primaryBack: string;
		secondaryFront: string;
		secondaryBack: string;
		driversLicense: string;
		autoInsurance: string;
	} | null = null;
	private initialPatientInfo: {
		firstName: string;
		lastName: string;
		dateOfBirth: string;
		patientEmail: string;
		clinicId: string;
		insuranceName: string;
		address: string;
		city: string;
		state: string;
		zip: string;
		relationshipToPatient: string;
		subscriberFirstName: string;
		subscriberLastName: string;
		daySubscriberDOB: string;
		secondarySubscriberFirstName: string;
		secondarySubscriberLastName: string;
		daySecondaryDOB: string;
		secondaryRelationshipToPatientNew: string;
		policyHolder: string;
	} | null = null;
	constructor(
		private router: Router,
		private loadingService: LoadingService,
		private route: ActivatedRoute,
		private cdRef: ChangeDetectorRef,
		private patientService: PatientService,
		private authService: AuthService,
		private tabTrackingService: TabTrackingService,
		private http: HttpClient,
		private signaturePdfService: SignaturePDFService,
		private fileUploadService: FileUploadService,
		private autosave: FormAutosaveService
	) {


	}

	@HostListener('window:pagehide')
	onPageHide() {
		this.autosave.flushOnUnload();
		this.performUnlockOnClose();
	}

	@HostListener('window:beforeunload')
	unloadNotification() {
		this.autosave.flushOnUnload();
		this.performUnlockOnClose();
	}


// private getFormPathByClinic(chiroLabel: string, createdDate?: string): string {
//     const shortFormClinics = environment.FORMIOV2_CODES?.split(",") || [];
    
//   	const thresholdDate = new Date('2026-03-18T00:00:00Z');
//     const isNewPatient = createdDate ? new Date(createdDate) > thresholdDate : true;

//     if (chiroLabel && shortFormClinics.includes(chiroLabel) && isNewPatient) {
//         return "intakev20"; 
//     }
//     return "intakeform";
// }

 private getFormPathByFormId(formId?: string): string {
    if (formId === environment.SHORTER_FORM_ID) {
        return "intakev20"; 
    }
    return "intakeform";
  }

	private unlockAttempted = false;
	private performUnlockOnClose() {
		// Prevent duplicate unlock attempts
		if (this.unlockAttempted) {
			return;
		}

		// Don't unlock during a takeover reload
		if (this.isTakingOver) {
			return;
		}

		sessionStorage.setItem(`is_refreshing_${this.submissionId}`, 'true');

		// If the browser already knows it's a reload, stop immediately
		if (this.isPageRefresh()) {
			return;
		}

		// Don't unlock if another tab has already taken over this form
		if (this.formTakenOver) {
			return;
		}

		if (this.submissionId && !this.isReadOnly && !this.isLockedByOtherUser && !this.isOpenInAnotherTab && !this.formSubmitted) {
			this.unlockAttempted = true;
			this.tabTrackingService.releaseLock(this.submissionId);

			const token = localStorage.getItem('formioToken');
			const unlockUrl = `${environment.BACKEND_URL}/submissions/${this.submissionId}/unlock`;

			const payload = JSON.stringify({ token, force: true });
			navigator.sendBeacon(unlockUrl, new Blob([payload], { type: 'text/plain' }));
		}
	}

	private isPageRefresh(): boolean {
		const refreshFlag = sessionStorage.getItem(`is_refreshing_${this.submissionId}`);
		if (refreshFlag === 'true') {
			return true;
		}

		const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
		if (navEntries.length > 0 && navEntries[0].type === 'reload') {
			return true;
		}

		return false;
	}

	get showInformedConsentTab(): boolean {
		return (
			this.availableTabs.some((x) => x === "Informed-Consent") ||
			this.formData?.data?.consentOfPrivacyInformedAA
		);
	}
	get showAATab(): boolean {
		return (
			this.availableTabs.some((x) => x === "Agreements-Authorizations") ||
			this.formData?.data?.consentOfPrivacyInformedAA
		);
	}
	get showTextConsent(): boolean {
		this.tabs[TabEnum.CommunicationsConsent].visible =
			!!this.formData?.data?.IsTextConsentInformed && this.formData.data.consentOfPrivacyInformedAA && !this.formData.data.IsNewConsent;
		return this.tabs[TabEnum.CommunicationsConsent].visible;
	}
	get showCCOF(): boolean {
		this.tabs[TabEnum.CCOF].visible =
			!!this.formData?.data?.IsCCOFConsent && this.formData.data.consentOfPrivacyInformedAA && !this.formData.data.IsNewConsent;
		return this.tabs[TabEnum.CCOF].visible;
	}
	get showNOPP(): boolean {
		this.tabs[TabEnum.ReceiptOfNOPP].visible =
			!!this.formData?.data?.IsNewConsent && this.formData.data.consentOfPrivacyInformedAA;
		return this.tabs[TabEnum.ReceiptOfNOPP].visible;
	}
	get showScribe(): boolean {
		const hasAnyScribeConsent = !!this.formData?.data?.IsScribeConsent || !!this.formData?.data?.IsNewScribeConsent;
		this.tabs[TabEnum.Scribe].visible = hasAnyScribeConsent && !!this.formData?.data?.consentOfPrivacyInformedAA;
		return this.tabs[TabEnum.Scribe].visible;
	}
	get getABNTab(): boolean {
		this.tabs[TabEnum.ABN].visible =
			this.formData?.data.isPatinetCoveredByInsurance === "Medicare" &&
			(this.formData?.data?.consentOfPrivacyInformedAA);
		return this.tabs[TabEnum.ABN].visible;
	}

	get showPITab(): boolean {
		this.tabs[TabEnum.PITemplate].visible =
			this.formData?.data?.isPatinetCoveredByInsurance === 'Automobile (Motor Vehicle Accident ONLY)' &&
			!!this.formData?.data?.IsPersonalInjury;
		return this.tabs[TabEnum.PITemplate].visible;
	}

	get showConsentFormsTab(): boolean {
		return this.formData?.data?.consentOfPrivacyInformedAA === true;
	}

	private formatDateTime(dateString: string): string {
		const d = new Date(dateString);
		
		return d.toLocaleString('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: true
		}).replace(',', ''); 
	}

	/**
	 * Listen for localStorage changes from other tabs to detect takeover in real-time.
	 * When another tab updates activeTabId, this tab knows it has been superseded.
	 */
	private setupCrossTabListener(): void {
		if (this.storageListener) {
			window.removeEventListener('storage', this.storageListener);
		}

		this.storageListener = (event: StorageEvent) => {
			if (!this.submissionId) return;

			const activeTabKey = `activeTabId_${this.submissionId}`;

			// Another tab changed the activeTabId for this submission
			if (event.key === activeTabKey && event.newValue && event.newValue !== this.tabInstanceId) {
				// Only matters if we're in edit mode (not already readonly)
				if (!this.isReadOnly && !this.isLockedByOtherUser && !this.isOpenInAnotherTab && !this.formTakenOver) {
					this.formTakenOver = true;
					this.formTakenOverBy = 'you in another tab';
					this.cdRef.detectChanges();

					alert(
						'This form has been taken over in another tab or window. ' +
						'Changes in this window can no longer be saved.'
					);
				}
			}
		};

		window.addEventListener('storage', this.storageListener);
	}

	// Reloads after a takeover so the user sees the other person's version
	// The "Unlock the form" button then lets them take it back
	reloadAfterTakeover(): void {
		// Nothing here can be saved now, don't flush or release a lock we lost
		this.autosave.stop();
		this.isTakingOver = true;
		window.location.reload();
	}

	// Server markers of the copy we are working from
	// Called on load and after every write of our own
	private captureServerFingerprint(submission: any): void {
		this.initialLastUnlockDateTime = submission?.data?.lastUnlockDateTime
			? new Date(submission.data.lastUnlockDateTime).toISOString()
			: null;
		this.knownModified = submission?.modified
			? new Date(submission.modified).toISOString()
			: null;
		const serverAutosavedAt = submission?.autosavedAt
			? new Date(submission.autosavedAt).toISOString()
			: null;
		// An autosave can land after the response we got was produced
		// Never step back to an older stamp, our own write would then look foreign
		if (!this.knownAutosavedAt || (serverAutosavedAt && serverAutosavedAt > this.knownAutosavedAt)) {
			this.knownAutosavedAt = serverAutosavedAt;
		}
	}

	// Keeps autosave out of an explicit save
	// Its stamp would land mid-save and the next check would read it as someone else
	private async beginManualSave(): Promise<void> {
		this.manualSaveInProgress = true;
		await this.autosave.whenIdle();
	}

	private endManualSave(): void {
		this.manualSaveInProgress = false;
	}

	// Autosave for an editable form
	// Baseline is taken on a delay, after FormIO applies defaults and conditionals
	// Earlier and the first delta would look like the whole form was filled in
	private startAutosave(form: any): void {
		if (!environment.AUTOSAVE_ENABLED) return;
		if (!this.submissionId) return;

		this.autosaveArmed = false;

		this.autosaveSub?.unsubscribe();
		this.autosaveSub = this.autosave.changes.subscribe((state) => {
			this.autosaveState = state;
			this.cdRef.detectChanges();
		});

		// Only a hint, the delta comes from the data itself
		// So a programmatic redraw can't produce a bogus write
		form.on("change", () => {
			if (!this.autosaveArmed) return;
			this.autosave.markDirty();
		});

		setTimeout(() => {
			this.autosave.start({
				submissionId: this.submissionId!,
				// Same function for baseline and reads, so a cancelled row gets removed too
				getData: () => this.dataWithOpenGridRows(),
				baseline: this.dataWithOpenGridRows(),
				canSave: () => this.canAutosave(),
				// Same gate as the explicit Save, refuses the write on a takeover
				beforeSave: () => this.checkLockAndConflictsBeforeSave(),
				// Remember our own stamp, so the next check doesn't read it as foreign
				onSaved: (autosavedAt) => {
					this.knownAutosavedAt = autosavedAt
						? new Date(autosavedAt).toISOString()
						: this.knownAutosavedAt;
				},
				intervalMs: environment.AUTOSAVE_INTERVAL_MS,
			});
			this.autosaveArmed = true;
		}, 1500);
	}

	// Autosave stays out of the way unless this tab owns the form
	private canAutosave(): boolean {
		return (
			!!this.submissionId &&
			!this.isReadOnly &&
			!this.isLockedByOtherUser &&
			!this.isOpenInAnotherTab &&
			!this.formTakenOver &&
			!this.formSubmitted &&
			!this.manualSaveInProgress
		);
	}

	async checkLockAndConflictsBeforeSave(): Promise<boolean> {
		// Quick check: if this tab was already notified of a takeover via storage event
		if (this.formTakenOver) {
			alert(
				'This form has been taken over in another tab or window. ' +
				'Changes in this window can no longer be saved.'
			);
			return false;
		}

		try {
			const latest = await this.patientService.getSubmission(this.submissionId!);
			const latestLockedBy = latest.data.lockedBy;

			const currentUser = this.authService.getUserData();
			const currentUserName = `${currentUser.firstName} ${currentUser.lastName}`;

			// If someone else took over the form
			if (latestLockedBy && latestLockedBy !== currentUserName) {
				console.log("Someone else locked it");
				const lockedDisplay = this.formatDateTime(latest.data.lockDateTime);
				const lockedByDisplay = latestLockedBy || "another user";

				this.formTakenOver = true;
				this.formTakenOverBy = lockedByDisplay;

				alert(
					`This form was taken over by ${lockedByDisplay} on ${lockedDisplay}. ` +
					`Saving is not allowed because another user is editing the form.`
				);
				return false;
			}

			// A force takeover clears lockedBy, so an empty lock proves nothing
			// Compare the unlock trail against what this tab saw when it loaded
			const latestLastUnlockAt = latest.data.lastUnlockDateTime
				? new Date(latest.data.lastUnlockDateTime).toISOString()
				: null;
			const latestLastUnlockedBy = latest.data.lastUnlockedBy?.toString() || "";
			const currentUserId = currentUser?._id?.toString() || "";

			if (
				latestLastUnlockAt !== this.initialLastUnlockDateTime &&
				latestLastUnlockedBy &&
				latestLastUnlockedBy !== currentUserId
			) {
				const takenOverBy = latestLockedBy || latest.data.updatedBy || "another user";
				this.formTakenOver = true;
				this.formTakenOverBy = takenOverBy;

				alert(
					`This form was taken over by ${takenOverBy} on ${this.formatDateTime(
						latest.data.lastUnlockDateTime
					)}. Saving is not allowed because it would overwrite their changes.`
				);
				return false;
			}

			// Someone else pressed Save while this tab sat on an older copy
			// `modified` only moves on an explicit save
			const latestModified = latest.modified ? new Date(latest.modified).toISOString() : null;
			if (
				latestModified !== this.knownModified &&
				latest.data.updatedBy &&
				latest.data.updatedBy !== currentUserName
			) {
				this.formTakenOver = true;
				this.formTakenOverBy = latest.data.updatedBy;

				alert(
					`${latest.data.updatedBy} saved changes to this form on ${this.formatDateTime(
						latest.modified
					)}. Saving is not allowed because it would overwrite their changes. ` +
					`Please reload to see their version.`
				);
				return false;
			}

			// Someone else autosaved, which moves neither `modified` nor `updatedBy`
			// The only trace is an `autosavedAt` our last write didn't produce
			const latestAutosavedAt = latest.autosavedAt
				? new Date(latest.autosavedAt).toISOString()
				: null;
			if (latestAutosavedAt && latestAutosavedAt !== this.knownAutosavedAt) {
				const editedBy = latestLockedBy || latest.data.updatedBy || "another user";
				this.formTakenOver = true;
				this.formTakenOverBy = editedBy;

				alert(
					`Someone else (${editedBy}) has been editing this form - their changes were ` +
					`saved on ${this.formatDateTime(latest.autosavedAt)}. Saving is not allowed ` +
					`because it would overwrite their work. Please reload to see their version.`
				);
				return false;
			}

			// If the same user has multiple tabs open
			const activeTabId = localStorage.getItem(`activeTabId_${this.submissionId}`);
			if (latestLockedBy && latestLockedBy === currentUserName) {
				if (activeTabId && activeTabId !== this.tabInstanceId) {
					// This tab is not the active one — another tab took over
					this.formTakenOver = true;
					alert(
						`You have taken control of this form in another tab or window. ` +
						`To prevent data loss, changes in this window cannot be saved.`
					);
					return false;
				}
			}

			return true;
		} catch (err) {
			console.error("Error in checkLockAndConflictsBeforeSave:", err);
			return true;
		}
	}

	//Saves but stays on the same page in readonly mode
	async saveIntakeAndStay(): Promise<void> {
		if (this.isReadOnly) return;
		if (!this.validateSubscriberFields()) return;

		await this.commitOpenGridRows();

		const form = this.form;
		this.loadingService.show();
		this.resetMessages();
		form.submission.data.localStatus = "Intake Form-Submitted";
		const userData = this.authService.getUserData();
		if (userData && userData.firstName) {
			form.submission.data.updatedBy = userData.firstName + " " + userData.lastName;
		}

		await this.beginManualSave();
		const canSave = await this.checkLockAndConflictsBeforeSave();
		if (!canSave) {
			this.endManualSave();
			this.loadingService.hide();
			return;
		}

		try {
			// Make the API request to update
			await this.patientService.updateSubmission(this.submissionId!, form.submission);
			await this.saveFormSnapshot();
			this.loadingService.show();

			if (this.formData.data.IsNewConsent) {
				await this.saveAASnapshotNew();
				await this.saveInformedConsentSnapshotNew();
				await this.saveNOPPSnapshot();
			} else {
				await this.saveAASnapshot();
				await this.saveInformedConsentSnapshot();
				await this.saveTextConsentSnapshot();
				await this.saveCCOFSnapshot();
			}
			await this.saveScribeSnapshot();
			if (this.showPITab) {
				await this.savePISnapshot();
			}

			// Mark form as successfully submitted
			this.formSubmitted = true;

			// Submission is saved and this tab reloads into readonly mode
			this.autosave.stop();

			await this.sendInsuranceImagesIfChanged();
			//this.sendIntakePdfToQueue();

			// Unlock the submission after successful submit
			if (this.submissionId) {
				await this.unlockSubmissionAfterSubmit();
			}

			this.showMessage("Form saved successfully");

			// Stay on the same page but switch to readonly mode
			//Using the hash-based URL format with /new-intake path for page refresh
			
			setTimeout(() => {
				// Update the URL to reflect readonly mode
				const url = `${window.location.origin}/#/new-intake/${this.submissionId}?mode=readonly`;
				window.history.replaceState({}, "", url);

				// Force refresh to reload in readonly mode
				window.location.reload();
				this.loadingService.hide();

			}, 5000);
		} catch (error: any) {
			console.error("Submission update error:", error);
			this.showError(`Failed to update submission: ${error.message || "Unknown error"}`);
		} finally {
			this.endManualSave();
			this.loadingService.hide();
		}
	}
	
	//saves and goes to next page
	async saveIntake(goToNextPage = false): Promise<void> {
		if (this.isReadOnly) {
			this.goNext();
			return;
		}
		if (!this.validateSubscriberFields()) return;

		await this.commitOpenGridRows();

		let form = this.form;
		this.loadingService.show();

		this.resetMessages();
		form.submission.data.localStatus = "Intake Form-Submitted";
		const userData = this.authService.getUserData();
		if (userData && userData.firstName) {
			form.submission.data.updatedBy = userData.firstName + " " + userData.lastName;
		}
		this._showAATab = true;
		this._showInformedConsentTab = true;
		this._showTextConsentTab = true;
		this.tabs[TabEnum.CommunicationsConsent].visible = true;
		this.tabs[TabEnum.CCOF].visible = true;
		this._showCCOF = true;

		await this.beginManualSave();
		const canSave = await this.checkLockAndConflictsBeforeSave();
		if (!canSave) {
			this.endManualSave();
			this.loadingService.hide();
			return;
		}

		if (this.getABNTab) {
			this.addDownloadABN();
		}
		if (this.showInformedConsentTab && this.showAATab){
			if (this.formData.data.IsNewConsent) {
				await this.renderInformedConsentNew();
				await this.renderAATabNew();
			} else {
				await this.renderInformedConsent();
				await this.renderAATab();
			}
		}
	
		this.patientService
			.updateSubmission(this.submissionId!, form.submission)
			.then(async (response) => {
			
				await this.saveFormSnapshot();
				if (this.formData.data.IsNewConsent) {
					await this.saveAASnapshotNew();
					await this.saveInformedConsentSnapshotNew();
					await this.saveNOPPSnapshot();
				} else {
					await this.saveAASnapshot();
					await this.saveInformedConsentSnapshot();
					await this.saveTextConsentSnapshot();
					await this.saveCCOFSnapshot();
					
				}
				await this.saveScribeSnapshot();
				if (this.showPITab) {
					await this.savePISnapshot();
				}

				this.formData.data.patientInformedConsentForm =
					response.submission.data.patientInformedConsentForm;
				this.formData.data.agreementsAuthorizations =
					response.submission.data.agreementsAuthorizations;
				this.formData.data.abnNestedForm = response.submission.data.abnNestedForm;

				this.showDownloadDropdown();

				// Queue insurance images to Curve on save (only when changed and eligible).
				await this.sendInsuranceImagesIfChanged();

				this.showMessage("Form saved successfully");
				// this.availableForms = await this.getFormDownloads();

				this.attachCardClickListeners(this.form);
				this.applyPanelLogic(this.form);
				if (goToNextPage) this.goNext();

				this.loadingService.hide();
			})
			.catch((error: any) => {
				console.error("Submission update error:", error);
				this.showError(`Failed to update submission: ${error.message || "Unknown error"}`);
				this.loadingService.hide();
			})
			.finally(() => this.endManualSave());
	}

	async saveABNForm(goToNextPage = false) {
		if (!this.pdfDoc) return;

		// Block saving only if ABN form is FULLY locked (both signature and date already in DB).
		// Old patients with only a signature (no date) can still edit to add the missing date.
		// if (this.isABNFormFullyLocked()) {
		// 	alert("This ABN form has already been signed and saved with a date and cannot be modified.");
		// 	return;
		// }

		// If the user has signed, they must also enter a date - the date is required and they won't be able to edit after save.
		if (this.abnForm.signatureAbn && !this.abnForm.signatureDate) {
			alert("Please enter the signature date before saving. Once both signature and date are saved, the form cannot be modified.");
			return;
		}
		if (!this.validateSubscriberFields()) return;

		await this.commitOpenGridRows();

		await this.beginManualSave();
		const canSave = await this.checkLockAndConflictsBeforeSave();
		if (!canSave) {
			this.endManualSave();
			this.loadingService.hide();
			return;
		}

		this.pdfDoc.embedFont(this._fontBytes!);
		
		this.loadingService.show();
		if (!this.isReadOnly) {
			const updatedPdfBytes = await this.pdfDoc.save();
			this.pdfABNSrc = new Uint8Array(updatedPdfBytes);
			if (!this.formData.data?.abnNestedForm?.data) {
			}
			const abnData: any = {
				patientFullNameABN: this.patientName,
				manipulativeTherapy: this.abnForm.manipulativeTherapy,
				physicalTherapy: this.abnForm.physicalTherapy,
				equipment: this.abnForm.orthotics,
				physicalExaminationsandTests: this.abnForm.physicalExams,
				x_Rays: this.abnForm.xRays,
				costAbn: this.abnForm.careCost?.toString(),
				check1: this.abnForm.billingAgreement,
				check2: this.abnForm.notBillMedicare,
				check3: this.abnForm.notBill,
				NotifierAbn: this.abnForm.notifier,
				dateTime: this.abnForm.signatureDate?.toString(),
				signatureAbn: this.abnForm.signatureAbn,
				abnFormVersion: this.abnForm.abnFormVersion ?? this.formData.data.abnNestedForm?.data?.abnFormVersion,
			};

			// manipulativeTreatment only exists on new ABN form - only save if using new form
			if (this.isUsingNewABNForm()) {
				abnData.manipulativeTreatment = this.abnForm.manipulativeTreatment;
			}

			this.formData.data.abnNestedForm = {
				data: abnData,
			};
			this.formData.data.localStatus = "Intake Form-Submitted";
			this.form.submission = this.formData;

			this.patientService
				.updateSubmission(this.submissionId!, this.form.submission)
				.then(async (response) => {
					this.formData.data.abnNestedForm = response.submission.data.abnNestedForm;
					await this.saveFormSnapshot();
					this.showDownloadDropdown();

					if (this.formData.data.IsNewConsent) {
						await this.saveAASnapshotNew();
						await this.saveInformedConsentSnapshotNew();
						await this.saveNOPPSnapshot();
					} else {
						await this.saveAASnapshot();
						await this.saveInformedConsentSnapshot();
						await this.saveTextConsentSnapshot();
						await this.saveCCOFSnapshot();
					}
					await this.saveScribeSnapshot();
					if (this.showPITab) {
						await this.savePISnapshot();
					}
					this.loadingService.hide();
					await this.renderABNForm(true);
					await this.renderPIForm();
					await this.renderScribeTab();

					await this.sendInsuranceImagesIfChanged();
					this.loadingService.hide();
					this.showMessage("ABN Form saved successfully");
					if (goToNextPage) {
						if (this.showPITab) {
							const piTab = document.getElementById("pi-tab");
							if (piTab) piTab.click();
							// await this.renderPIForm();
						} else {
							this.goToConsentForms();
						}
					}
				})
				.catch((error: any) => {
					console.error("Submission update error:", error);
					this.showError(`Failed to update submission: ${error.message || "Unknown error"}`);
					this.loadingService.hide();
				})
				.finally(() => this.endManualSave());
		} else {
			this.endManualSave();
		}
	}

	formatDateDashed(date: Date | null | undefined | string): string {
		if (!date) return "";
		if (typeof date === "string") {
			return date;
		}
		const two = (n: number) => String(n).padStart(2, "0");
		return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}`;
	}
	formatToCST(date: Date): string {
		// Create a copy of the date adjusted to CST (UTC-6)
		const utc = date.getTime() + date.getTimezoneOffset() * 60000;
		const cstOffset = -6 * 60; // CST is UTC-6
		const cstTime = new Date(utc + cstOffset * 60000);

		const month = (cstTime.getMonth() + 1).toString().padStart(2, "0");
		const day = cstTime.getDate().toString().padStart(2, "0");
		const year = cstTime.getFullYear().toString().slice(-2);

		let hours = cstTime.getHours();
		const minutes = cstTime.getMinutes().toString().padStart(2, "0");
		const ampm = hours >= 12 ? "PM" : "AM";

		hours = hours % 12;
		hours = hours ? hours : 12; // 0 should be 12

		return `${month}/${day}/${year} ${hours}:${minutes} ${ampm} CST`;
	}
	normalizeFormData(date: any) {
		// Ensure the date field is always stored as a string in MM-DD-YYYY format
		if (date) {
			if (date instanceof Date) {
				// If Form.io converted it to a Date object, convert back to string
				const d = date;
				const mm = String(d.getMonth() + 1).padStart(2, "0");
				const dd = String(d.getDate()).padStart(2, "0");
				const yyyy = d.getFullYear();
				date = `${mm}-${dd}-${yyyy}`;
			} else if (typeof date === "string") {
				const tempDate = date.split("T")[0];
				const [yyyy, mm, dd] = tempDate.split("-");
				date = String(date);
			}
		}
		return date;
	}
	formatDate(input: Date | string | null | undefined): string {
		if (!input) return "";

		// helper to format numbers as two digits
		const two = (n: number) => String(n).padStart(2, "0");

		if (typeof input === "string") {
			const s = input.trim();

			// 1) Try ISO-like YYYY-MM-DD at the start (ignores time & timezone)
			const isoMatch = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
			if (isoMatch) {
				const year = parseInt(isoMatch[1], 10);
				const month = parseInt(isoMatch[2], 10); // 1-12
				const day = parseInt(isoMatch[3], 10);

				// build a Date using local components so there's no UTC shifting
				// (new Date(year, month-1, day) -> local midnight for that Y-M-D)
				// We don't actually need the Date object for formatting, but it's useful for validation:
				const d = new Date(year, month - 1, day);
				if (!isNaN(d.getTime())) {
					return `${two(month)}/${two(day)}/${d.getFullYear()}`;
				}
				return "";
			}

			// 2) Try MM/DD/YYYY
			const usMatch = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
			if (usMatch) {
				const month = parseInt(usMatch[1], 10);
				const day = parseInt(usMatch[2], 10);
				const year = parseInt(usMatch[3], 10);
				return `${two(month)}/${two(day)}/${year}`;
			}

			// 3) All-digits -> treat as a timestamp (ms)
			if (/^\d+$/.test(s)) {
				const ts = Number(s);
				const d = new Date(ts);
				if (!isNaN(d.getTime())) {
					return `${two(d.getMonth() + 1)}/${two(d.getDate())}/${d.getFullYear()}`;
				}
				return "";
			}

			// 4) Fallback: try Date parsing (may apply timezone shifts; only use if others fail)
			const parsed = new Date(s);
			if (!isNaN(parsed.getTime())) {
				return `${two(parsed.getMonth() + 1)}/${two(parsed.getDate())}/${parsed.getFullYear()}`;
			}

			return "";
		} else {
			// input is a Date object — use getDate() not getDay(), and add +1 to getMonth()
			const d = input as Date;
			return `${two(d.getMonth() + 1)}/${two(d.getDate())}/${d.getFullYear()}`;
		}
	}

	async ngOnInit() {
		this.tabInstanceId = crypto.randomUUID();
		console.log("THIS TAB INSTANCE ID: ", this.tabInstanceId)
		this.loadingService.show();
		this.isLoading = true;

		const fontBytes = await fetch('assets/fonts/DejaVuSans.ttf').then(r => r.arrayBuffer());
		this._fontBytes = fontBytes;
		try {
			this.token = localStorage.getItem("formioToken");
			if (this.token) {
				Formio.setToken(this.token);
			}
			this.routeSub = this.route.paramMap.subscribe(async (params) => {
				this.submissionId = params.get("id");

				this.destroyForm();
				this.route.queryParams.subscribe((queryParams) => {
					this.isReadOnly = queryParams["mode"] === "readonly";
					if (this.isReadOnly) {
						this.readingMode = true;
					}
				});
				if (this.submissionId) {
					await this.loadExistingSubmission();
					this.addDownloadIntakeForm();

					 await this.renderABNForm(true);
					if (this.showPITab) {
						await this.renderPIForm();
					}
					if(this.showScribe){
						await this.renderScribeTab();
					}
					this.showDownloadDropdown();
				}
				await this.renderForm();
				this._showAATab = this.showAATab;
				this._showCCOF = this.showCCOF;
				this._showInformedConsentTab = this.showInformedConsentTab;
				this._showTextConsentTab = this.showTextConsent;
				this._showScribe = this.showScribe;

				this.isLoading = false;

				this.cdRef.detectChanges();
				if (this.showInformedConsentTab && this.showAATab){
					if (this.formData.data.IsNewConsent) {
						await this.renderInformedConsentNew();
						await this.renderNOPPTab();
						await this.renderAATabNew();
					} else {
						await this.renderInformedConsent();
						await this.renderCCOFTab();
						await this.renderPdfTextConsent();
						await this.renderAATab();
						await this.renderScribeTab();
					}
				}

				setTimeout(() => {
					this.saveFormSnapshot();
					if (this.formData.data.IsNewConsent) {
						this.saveAASnapshotNew();
						this.saveInformedConsentSnapshotNew();
						this.saveNOPPSnapshot();
					} else {
						this.saveAASnapshot();
						this.saveInformedConsentSnapshot();
						this.saveTextConsentSnapshot();
						this.saveCCOFSnapshot();
					}
					this.saveScribeSnapshot();
					if (this.showPITab) {
						this.savePISnapshot();
					}
					this.loadingService.hide();
				}, 2000);
			});
		} catch (error: any) {
			console.error("Error initializing form:", error);
			this.loadingService.hide();
			this.isLoading = false;
			this.showError(error.message || "An error occurred during initialization");
		}
	}
	openSignatureModal() {
		// Prevent re-signing if a signature already exists in DB - signatures cannot be changed once captured.
		// (Date can still be added separately for old patients with signature but no date.)
		if (this.formData.data?.abnNestedForm?.data?.signatureAbn) {
			alert("This ABN form has already been signed. The signature cannot be changed.");
			return;
		}

		this.showSignatureModal = true;
		setTimeout(() => {
			// Initialize the signature pad
			this.signaturePad = this.signaturePdfService.initializeSignaturePad(
				this.signatureCanvas.nativeElement
			);
			const canvas = this.signatureCanvas.nativeElement;
			const ctx = canvas.getContext("2d");
			if (ctx) {
				ctx.fillStyle = "white";
				ctx.fillRect(0, 0, canvas.width, canvas.height);
			}

			// If there is an existing signature, load it
			// const existingSignature = this.formData?.data?.abnNestedForm.data.signatureAbn;
			const existingSignature = this.abnForm.signatureAbn;
			if (existingSignature) {
				this.signaturePad.fromDataURL(existingSignature, {
					// optional options
					ratio: 1,
					width: this.signatureCanvas.nativeElement.width,
					height: this.signatureCanvas.nativeElement.height,
					// transparent background
				});
			}
		}, 100);
	}
	clearSignature() {
		this.signaturePad.clear();
	}

	async renderSignatureOnPDF() {
		if (!this.pdfDoc) {
			return;
		}
		if (!this.abnForm.signatureAbn) {
			// Draw the image on the desired page
			const pages = this.pdfDoc.getPages();
			const targetPage = pages[0];

			targetPage.drawRectangle({
				x: 130,
				y: 144,
				width: 180,
				height: 30,
				color: rgb(1, 1, 1), // white background
			});
			console.warn("Missing signature data or PDF document.");
			return;
		}

		try {
			// Convert base64 string to byte array
			const response = await fetch(this.abnForm.signatureAbn);
			const signatureImageBytes = await response.arrayBuffer();

			// Embed the PNG image into the PDF
			const signatureImage = await this.pdfDoc.embedPng(signatureImageBytes);

			// Draw the image on the desired page
			const pages = this.pdfDoc.getPages();
			const targetPage = pages[0];

			targetPage.drawRectangle({
				x: 130,
				y: 144,
				width: 180,
				height: 30,
				color: rgb(1, 1, 1), // white background
			});
			targetPage.drawImage(signatureImage, {
				x: 130,
				y: 144,
				width: 180,
				height: 30,
			});
		} catch (error) {
			console.error("Error embedding signature image into PDF:", error);
		}
	}

	async saveSignature() {
		if (!this.pdfDoc) return;
		const pages = this.pdfDoc.getPages();
		const targetPage = pages[0];
		const dataUrl = this.signaturePad.toDataURL("image/png");

		if (!this.signaturePad || this.signaturePad.isEmpty()) {
			// Draw white rectangle if no signature
			targetPage.drawRectangle({
				x: 130,
				y: 144,
				width: 180,
				height: 30,
				color: rgb(1, 1, 1), // white fill
			});

			// Also clear from form state if needed
			this.abnForm = { ...this.abnForm, signatureAbn: null };
			//this.formData.data.abnNestedForm.data.signatureAbn = null;
			// Save the PDF
			this.pdfABNBytes = await this.pdfDoc.save();
			this.pdfABNSrc = new Uint8Array(this.pdfABNBytes);
			await this.renderABNForm();
			this.closeSignatureModal();
			return;
		}
		// Save to your form state
		// Only set abnFormVersion to "new" if it's not already set (new patient), preserve old value for existing patients
		const updatedAbnForm = { ...this.abnForm, signatureAbn: dataUrl };
		if (this.abnForm.abnFormVersion === undefined || this.abnForm.abnFormVersion === null) {
			updatedAbnForm.abnFormVersion = "new";
		}
		this.abnForm = updatedAbnForm;
		//this.formData.data.abnNestedForm.data.signatureAbn = dataUrl;

		// Embed into PDF
		const response = await fetch(dataUrl);
		const signatureImageBytes = await response.arrayBuffer();
		const signatureImage = await this.pdfDoc.embedPng(signatureImageBytes);

		targetPage.drawRectangle({
			x: 130,
			y: 144,
			width: 180,
			height: 30,
			color: rgb(1, 1, 1), // white background
		});
		targetPage.drawImage(signatureImage, {
			x: 130,
			y: 144,
			width: 180,
			height: 30,
		});

		// Save the PDF
		this.pdfABNBytes = await this.pdfDoc.save();
		this.pdfABNSrc = new Uint8Array(this.pdfABNBytes);
		await this.renderABNForm();

		this.closeSignatureModal();
	}
	closeSignatureModal() {
		this.showSignatureModal = false;
	}

	/**
	 * "YYYY-MM-DD Form-Name First Last", the naming convention for every download in this view
	 */
	private downloadFileName(formName: string): string {
		return buildDownloadFileName(
			formName,
			this.formData?.data?.firstName,
			this.formData?.data?.lastName
		);
	}

	/**
	 * Download a specific form by index
	 */
	async downloadSinglePdf(index: number) {
		if (index < 0 || index >= this.availableForms.length) {
			this.showError("Invalid form selection");
			return;
		}

		this.resetMessages();
		this.loadingService.show();

		const form = this.availableForms[index];

		try {
			if (form.name.includes("Consent-Forms")) {
				// Download merged consent forms
				const mergedBytes = await this.mergeConsentPDFs();
				await this.signaturePdfService.downloadPDF(
					this.downloadFileName("Consent-Forms"),
					mergedBytes
				);
			} else if (form.name.includes("ABN")) {
				if (!this.pdfDocDownload) {
					await this.createDownloadCopy();
				}
				if (!this.pdfABNBytesDownLoad) {
					this.showError(`Failed to download ABN-Form: Unknown error`);
					return;
				}

				await this.signaturePdfService.downloadPDF(
					this.downloadFileName("ABN-Form"),
					this.pdfABNBytesDownLoad
				);
			} else if (form.name.includes('Personal')) {
				if (!this.pdfPIBytes) {
					await this.renderPIForm();
				}
				if (!this.pdfPIBytes) {
					this.showError('Failed to download PI-Form: Unknown error');
					return;
				}
				await this.signaturePdfService.downloadPDF(
					this.downloadFileName("Personal-Injury-Consent-Form"),
					this.pdfPIBytes
				);
			} else if (form.name.includes("Receipt") || form.name.includes("NOPP")) {
				this.signaturePdfService.downloadPDF(
					this.downloadFileName("Receipt-Of-NOPP"),
					this.pdfBytesNOPPSnapshot!
				);
			} else {
				await this.downloadPDFIntake();
			}

			this.showMessage(`Form "${form.name}" downloaded successfully`);
		} catch (error: any) {
			this.showError(`Failed to download ${form.name}: ${error.message || "Unknown error"}`);
		} finally {
			this.loadingService.hide();
		}
	}

	/**
	 * Dismiss error message
	 */
	dismissError() {
		this.downloadError = null;
		this.cdRef.detectChanges();
	}

	/**
	 * Dismiss success message
	 */
	dismissMessage() {
		this.downloadMessage = null;
		this.cdRef.detectChanges();
	}

	/**
	 * Display error message
	 */
	private showError(message: string) {
		this.downloadError = message;
		this.downloadMessage = null;
		this.cdRef.detectChanges();
		console.error(message);
	}

	/**
	 * Display success message
	 */
	private showMessage(message: string) {
		this.downloadMessage = message;
		this.downloadError = null;
		this.cdRef.detectChanges();
	}

	/**
	 * Reset error and success messages
	 */
	private resetMessages() {
		this.downloadError = null;
		this.downloadMessage = null;
		this.cdRef.detectChanges();
	}

	/**
	 * When the patient is not the main policy holder, subscriber details and the
	 * relationship to the patient are required. Shows a toast error and returns
	 * false when any are missing; returns true otherwise.
	 */
	private validateSubscriberFields(): boolean {
		const data = this.form?.submission?.data || this.formData?.data || {};
		const container6 = data?.container6 || {};

		// "Who is the main subscriber or Policy holder?" is required for every insurance except the ones below
		const insurancesWithoutPolicyHolder = [
			"Automobile (Motor Vehicle Accident ONLY)",
			"Workers Comp (Injury During Work ONLY)",
			"None/Selfpay",
		];
		if (
			data?.isPatinetCoveredByInsurance &&
			!insurancesWithoutPolicyHolder.includes(data.isPatinetCoveredByInsurance) &&
			!container6.ifInsuredWhoIsTheMainSubscriberOrPolicyHolder
		) {
			this.showError("Please complete the following required field: Who is the main subscriber or Policy holder?");
			return false;
		}

		if (container6.ifInsuredWhoIsTheMainSubscriberOrPolicyHolder !== "Other") {
			return true;
		}

		const missingSubscriberFields = [
			!container6.subscriberName && !container6.subscriberFirstName ? "Subscriber First Name" : null,
			!container6.subscriberName && !container6.subscriberLastName ? "Subscriber Last Name" : null,
			!container6.subscriberbirthDate && !container6.daySubscriberDOB ? "Subscriber Date of Birth" : null,
			!container6.relationshipToPatient && !container6.relationshipToPatientNew ? "Relationship to Guarantor" : null,
		].filter(Boolean);

		if (missingSubscriberFields.length > 0) {
			this.showError(
				`The following fields are required when the patient is not the main policy holder: ${missingSubscriberFields.join(", ")}.`
			);
			return false;
		}

		return true;
	}

	// Live form first so a mid session clinic change counts
	private get clinicCode(): string {
		return (
			this.form?.submission?.data?.selectChiroCenter ||
			this.formData?.data?.selectChiroCenter ||
			""
		);
	}

	// Alaska gets the logo-free versions, see unbranded-forms.util
	consentPdfUrl(fileName: string): string {
		return unbrandedConsentPdfUrl(this.clinicCode, fileName);
	}

	resolveTemplate(pdfPath: string): string {
		return unbrandedTemplatePath(this.clinicCode, pdfPath);
	}

	// Falls back to branded when the Alaska file is missing, as with nopp.pdf
	async loadTemplate(
		pdfPath: string
	): Promise<{ bytes: ArrayBuffer; layout?: LayoutRemap[]; signatureHeight?: number }> {
		const unbrandedPath = this.resolveTemplate(pdfPath);

		if (unbrandedPath !== pdfPath) {
			try {
				const bytes = await this.http
					.get(unbrandedPath, { responseType: "arraybuffer" })
					.toPromise();
				return {
					bytes: bytes!,
					layout: unbrandedTemplateLayout(unbrandedPath),
					signatureHeight: unbrandedSignatureHeight(unbrandedPath),
				};
			} catch {
				console.warn(`Unbranded template not found, falling back to branded: ${unbrandedPath}`);
			}
		}

		const bytes = await this.http.get(pdfPath, { responseType: "arraybuffer" }).toPromise();
		return { bytes: bytes! };
	}

	async drawValuesOnPdf(
		pdfPath: string,
		pdfBytesOverride: Uint8Array | null = null,
		values: { text: string | ArrayBuffer; x: number; y: number; page: number }[],
		pdfDoc: PDFDocument | null = null
	) {
		var pdfBytes = null;
		let signatureHeight = 30;
		if (pdfBytesOverride) {
			pdfBytes = pdfBytesOverride;
		} else {
			const template = await this.loadTemplate(pdfPath);
			pdfBytes = template.bytes;
			signatureHeight = template.signatureHeight ?? signatureHeight;
			const layout = template.layout;
			if (layout) {
				values = values.map((val) => {
					const remap = layout.find((r) => r.from.x === val.x && r.from.y === val.y);
					return remap ? { ...val, x: remap.to.x, y: remap.to.y } : val;
				});
			}
		}

		if (!pdfDoc) pdfDoc = await PDFDocument.load(pdfBytes!);

		pdfDoc.registerFontkit(fontkit);
		const unicodeFont = await pdfDoc.embedFont(this._fontBytes!);
		const pages = pdfDoc.getPages();
		values.forEach(async (val) => {
			// Skip if val.text is null or undefined
			if (val.text == null) {
				return;
			}
			
			let image;
			if (
				typeof val.text === typeof ArrayBuffer ||
				val.text.toString().startsWith("data:image/png")
			) {
				image = await pdfDoc.embedPng(val.text);
				const { width: originalWidth, height: originalHeight } = image.scale(1); // get original dimensions

				const fixedHeight = signatureHeight;
				const scaleFactor = fixedHeight / originalHeight;
				const calculatedWidth = originalWidth * scaleFactor;

				pages[val.page].drawImage(image, {
					x: val.x,
					y: val.y,
					width: calculatedWidth,
					height: fixedHeight,
				});
			} else {
				pages[val.page].drawText(val.text.toString(), {
					x: val.x,
					y: val.y,
					size: 12,
					font: unicodeFont,
					color: rgb(0, 0, 0),
				});
			}
		});

		const filledPdfBytes = await pdfDoc.save();
		return filledPdfBytes;
	}

	async downloadPDFIntake() {

		if (!this.savedFormHtml) {
			await this.saveFormSnapshot();
		}

		// Update form values in saved HTML before sending
		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = this.savedFormHtml || "";
		var fullHtml = `
			<!DOCTYPE html>
			<html>
			<head>
				<meta charset="UTF-8">
				<title>${this.formData.data.firstName}-${this.formData.data.lastName}-Intake-Form </title>
				${this.savedStyles}
			</head>
			<body>
				${tempDiv.innerHTML}
			</body>
			</html>
		`;
		this.loadingService.show();
		await this.signaturePdfService.tryDownloadIntake(fullHtml, this.headerIntake!, 3)
				.finally(()=> this.loadingService.hide());

		this.showMessage(`Form "${this.downloadFileName("Intake-Form")}" downloaded successfully!`);
	}

	private extractImageUrl(value: any): string {
		if (!value) return "";
		if (typeof value === "string") return value;
		if (Array.isArray(value) && value[0]?.url) return value[0].url;
		if (typeof value === "object" && value.url) return value.url;
		return "";
	}

	private stripQuery(url: string): string {
		return url ? url.split("?")[0] : "";
	}

	private getCurrentInsuranceImages(): {
		primaryFront: string;
		primaryBack: string;
		secondaryFront: string;
		secondaryBack: string;
		driversLicense: string;
		autoInsurance: string;
	} {
		// Prefer the live form submission so we see the user's in-session edits;
		// fall back to the loaded data (e.g. at load, before the form is rendered,
		// which is when the initial baseline is captured).
		const data = this.form?.submission?.data || this.formData?.data || {};
		return {
			primaryFront: this.extractImageUrl(data.container6?.fileUploadFront),
			primaryBack: this.extractImageUrl(data.container6?.fileUploadBack),
			secondaryFront: this.extractImageUrl(data.container4?.secondarylicenseUploadFront),
			secondaryBack: this.extractImageUrl(data.container4?.secondarylicenseUploadBack),
			driversLicense: this.extractImageUrl(data.licenseUploadFront),
			autoInsurance: this.extractImageUrl(data.uploadYourAutoInsurance),
		};
	}

	private captureInitialInsuranceInfo(): void {
		this.initialInsuranceImages = this.getCurrentInsuranceImages();
		this.initialPatientInfo = this.getCurrentPatientInfo();
	}

	private getCurrentPatientInfo(): {
		firstName: string;
		lastName: string;
		dateOfBirth: string;
		patientEmail: string;
		clinicId: string;
		insuranceName: string;
		address: string;
		city: string;
		state: string;
		zip: string;
		relationshipToPatient: string;
		subscriberFirstName: string;
		subscriberLastName: string;
		daySubscriberDOB: string;
		secondarySubscriberFirstName: string;
		secondarySubscriberLastName: string;
		daySecondaryDOB: string;
		secondaryRelationshipToPatientNew: string;
		policyHolder: string;
	} {
		// Prefer the live form submission so we see the user's in-session edits;
		// fall back to the loaded data (e.g. at load, before the form is rendered,
		// which is when the initial baseline is captured).
		const data = this.form?.submission?.data || this.formData?.data || {};
		return {
			firstName: data.firstName || "",
			lastName: data.lastName || "",
			dateOfBirth: data.day || "",
			patientEmail: data.patientEmail || data.dynamicEmail || "",
			clinicId: data.selectChiroCenter || "",
			insuranceName: data.isPatinetCoveredByInsurance || "",
			address: data.addresspatientInfo || "",
			city: data.cityPatientInfo || "",
			state: data.statepatientInfo || "",
			zip: data.zipPatientInfo || "",
			relationshipToPatient: data?.container6?.relationshipToPatientNew || "",
			subscriberFirstName: data?.container6?.subscriberFirstName || "",
			subscriberLastName: data?.container6?.subscriberLastName || "",
			daySubscriberDOB: data?.container6?.daySubscriberDOB || "",
			secondarySubscriberFirstName: data?.container4?.secondarySubscriberFirstName || "",
			secondarySubscriberLastName: data?.container4?.secondarySubscriberLastName || "",
			daySecondaryDOB: data?.container4?.daySecondaryDOB || "",
			secondaryRelationshipToPatientNew: data?.container4?.secondaryRelationshipToPatientNew || "",
			policyHolder: data?.container6?.ifInsuredWhoIsTheMainSubscriberOrPolicyHolder || "",
		};
	}

	private insuranceImagesChangedSinceLoad(): boolean {
		if (!this.initialInsuranceImages) return false;
		const current = this.getCurrentInsuranceImages();
		const initial = this.initialInsuranceImages;
		return (
			this.stripQuery(current.primaryFront) !== this.stripQuery(initial.primaryFront) ||
			this.stripQuery(current.primaryBack) !== this.stripQuery(initial.primaryBack) ||
			this.stripQuery(current.secondaryFront) !== this.stripQuery(initial.secondaryFront) ||
			this.stripQuery(current.secondaryBack) !== this.stripQuery(initial.secondaryBack) ||
			this.stripQuery(current.driversLicense) !== this.stripQuery(initial.driversLicense) ||
			this.stripQuery(current.autoInsurance) !== this.stripQuery(initial.autoInsurance)
		);
	}

	private patientInfoChangedSinceLoad(): boolean {
		if (!this.initialPatientInfo) return false;
		const current = this.getCurrentPatientInfo();
		const initial = this.initialPatientInfo;
		return (
			current.firstName !== initial.firstName ||
			current.lastName !== initial.lastName ||
			current.dateOfBirth !== initial.dateOfBirth ||
			current.patientEmail !== initial.patientEmail ||
			current.clinicId !== initial.clinicId ||
			current.insuranceName !== initial.insuranceName ||
			current.address !== initial.address ||
			current.city !== initial.city ||
			current.state !== initial.state ||
			current.zip !== initial.zip ||
			current.relationshipToPatient !== initial.relationshipToPatient ||
			current.subscriberFirstName !== initial.subscriberFirstName ||
			current.subscriberLastName !== initial.subscriberLastName ||
			current.daySubscriberDOB !== initial.daySubscriberDOB ||
			current.secondarySubscriberFirstName !== initial.secondarySubscriberFirstName ||
			current.secondarySubscriberLastName !== initial.secondarySubscriberLastName ||
			current.daySecondaryDOB !== initial.daySecondaryDOB ||
			current.secondaryRelationshipToPatientNew !== initial.secondaryRelationshipToPatientNew ||
			current.policyHolder !== initial.policyHolder
		);
	}

	private async sendInsuranceImagesIfChanged(): Promise<void> {
		// Only send when something changed since the initial load — or since the
		// last successful send, because we re-baseline after the POST below.
		if (!this.insuranceImagesChangedSinceLoad() && !this.patientInfoChangedSinceLoad()) return;

		const submissionId = this.formData?._id || this.submissionId || "";
		if (!submissionId) return;

		// Prefer the live form submission so we see the user's in-session edits;
		// fall back to the loaded data (e.g. at load, before the form is rendered,
		// which is when the initial baseline is captured).
		const data = this.form?.submission?.data || this.formData?.data || {};
		const current = this.getCurrentInsuranceImages();

		const clinicCode = data.selectChiroCenter || "";
		const allowedClinics = environment.QUEUE_ALLOWED_CLINICS || [];
		const allAllowed = allowedClinics.includes('*');
		
		if (!allAllowed && !allowedClinics.includes(clinicCode)) return;

		// Gate which submissions are eligible to be queued to Curve.
		const insuranceType = data.isPatinetCoveredByInsurance || "";

		// No insurance selection — nothing to send.
		if (!insuranceType) return;

		// Self-pay, MVA, Workers Comp and VA patients do not get a Curve record
		if (CURVE_EXCLUDED_INSURANCES.includes(insuranceType)) return;

		// A drivers license must be uploaded before we send anything.
		if (!current.driversLicense) return;

		// The primary insurance photos are required
		if (!current.primaryFront || !current.primaryBack) return;

		try {
				if (!this.savedFormHtml) {
					await this.saveFormSnapshot();
				}
				const tempDiv = document.createElement("div");
				tempDiv.innerHTML = this.savedFormHtml || "";
				const fullHtml = `
					<!DOCTYPE html>
					<html>
					<head>
						<meta charset="UTF-8">
						<title>${this.formData.data.firstName}-${this.formData.data.lastName}-Intake-Form </title>
						${this.savedStyles}
					</head>
					<body>
						${tempDiv.innerHTML}
					</body>
					</html>
				`;

				this.http.post(`${environment.BACKEND_URL}/queue/queue-data`, {
					submissionId:submissionId,
					firstName: data.firstName || "",
					lastName: data.lastName || "",
					dateOfBirth: data.day || "",
					patientEmail: data.patientEmail || data.dynamicEmail || "",
					clinicId: data.selectChiroCenter || "",
					salesforceAccountId: data.salesforceAccountId || "",
					insuranceName: data.isPatinetCoveredByInsurance || "",
					address: data.addresspatientInfo || "",
					city: data.cityPatientInfo || "",
					state: data.statepatientInfo || "",
					zip: data.zipPatientInfo || "",
					insuranceCardFrontUrl: current.primaryFront,
					insuranceCardBackUrl: current.primaryBack,
					secondaryInsuranceCardFrontUrl: current.secondaryFront,
					secondaryInsuranceCardBackUrl: current.secondaryBack,
					driversLicense: current.driversLicense,
					autoInsuranceUrl: current.autoInsurance,
					intakeHTML: fullHtml,
					relationshipToPatient: data?.container6?.ifInsuredWhoIsTheMainSubscriberOrPolicyHolder === "Self"
						? data.container6.ifInsuredWhoIsTheMainSubscriberOrPolicyHolder
						: (data?.container6?.relationshipToPatientNew || ""),
					subscriberFirstName: data?.container6?.subscriberFirstName || "",
					subscriberLastName: data?.container6?.subscriberLastName || "",
					subscriberDOB: data?.container6?.daySubscriberDOB || "",
					secondarySubscriberFirstName: data?.container4?.secondarySubscriberFirstName || "",
					secondarySubscriberLastName: data?.container4?.secondarySubscriberLastName || "",
					secondaryDOB: data?.container4?.daySecondaryDOB || "",
					secondaryRelationshipToPatient: data?.container4?.secondaryRelationshipToPatientNew || ""
				}).subscribe({
					// Re-baseline after a successful send so the next save only
					// re-triggers when something changes again.
					next: () => this.captureInitialInsuranceInfo(),
					error: (err) => console.error("Failed to send data to queue:", err),
				});
			
		} catch (err) {
			console.error("Failed to send insurance images to queue:", err);
		}
	}


	async mergeConsentPDFs(): Promise<Uint8Array> {
		const consentPdfs: { bytes: Uint8Array | null, name: string }[] = [
			{ bytes: this.pdfBytesSnapshot, name: 'Informed Consent' },
			{ bytes: this.pdfBytesAASnapshot, name: 'Payment Agreements & Authorizations' },
		];

		// If IsNewConsent is true, include Receipt of NOPP instead of legacy forms
		if (this.formData.data.IsNewConsent) {
			if (this.showNOPP && this.pdfBytesNOPPSnapshot) {
				consentPdfs.push({ bytes: this.pdfBytesNOPPSnapshot, name: 'Receipt of NOPP' });
			}

			const { bytes: response } = await this.loadTemplate('assets/nopp.pdf');
			if (this.showScribe && this.pdfScribeBytesSnapshot) {
				consentPdfs.push({ bytes: this.pdfScribeBytesSnapshot, name: 'State Biometric Privacy Laws' });
			}
			const noppPdfBytes =  new Uint8Array(response);
			consentPdfs.push({ bytes: noppPdfBytes, name: 'NOPP' });
			
		} else {
			// Legacy flow: include Communications Consent and CCOF if applicable
			if (this.showTextConsent && this.pdfTextBytesSnapshot) {
				consentPdfs.push({ bytes: this.pdfTextBytesSnapshot, name: 'Communications Consent' });
			}

			if (this.showCCOF && this.pdfBytesCCOFSnapshot) {
				consentPdfs.push({ bytes: this.pdfBytesCCOFSnapshot, name: 'Credit Card On File' });
			}
		
			const response = await firstValueFrom(
				this.http.get(this.consentPdfUrl('Notice_of_Privacy_Practices_IL_v2-2.pdf'), {
					responseType: 'arraybuffer'
				})
			);
			const ccofPDFBytes =  new Uint8Array(response);
			consentPdfs.push({ bytes: ccofPDFBytes, name: 'CCOF' });
		}


		return await this.signaturePdfService.mergeConsentPDFs(consentPdfs);
	}


	private async fixCanvasAndSVGPositions(clonedForm: HTMLElement): Promise<void> {
		const containers = clonedForm.querySelectorAll(".formio-sketchpad-container");

		containers.forEach((container: any) => {
			const background = container.querySelector(".formio-sketchpad-background");
			const canvas = container.querySelector(".formio-sketchpad-canvas");
			const backgroundImg = background?.querySelector("img");
			const svg = canvas?.querySelector("svg");

			if (backgroundImg && svg) {
				const width = backgroundImg.getAttribute("width") || backgroundImg.width;
				const height = backgroundImg.getAttribute("height") || backgroundImg.height;

				svg.setAttribute("width", width.toString());
				svg.setAttribute("height", height.toString());
				svg.style.width = `${width}px`;
				svg.style.height = `${height}px`;

				canvas.style.position = "absolute";
				canvas.style.top = "0";
				canvas.style.left = "0";
				canvas.style.width = `${width}px`;
				canvas.style.height = `${height}px`;

				container.style.position = "relative";
				container.style.width = `${width}px`;
				container.style.height = `${height}px`;
			}
		});

		await new Promise((resolve) => setTimeout(resolve, 50));
	}

	async createDownloadCopy() {
		if (!this.pdfDoc) {
			this.showError(`Failed to download ABN-Form: PDF not loaded`);
			return;
		}

		// Save the current PDF with all its form data
		const currentPdfBytes = await this.pdfDoc.save();

		// Load a fresh copy from those bytes (this preserves all form data)
		this.pdfDocDownload = await PDFDocument.load(currentPdfBytes);

		// Now get the form and enable readonly on all fields
		const form = this.pdfDocDownload.getForm();
		const fields = form.getFields();

		fields.forEach((field) => {
			field.enableReadOnly();
		});

		// The copy exists only to be downloaded, so it carries the download naming convention
		this.pdfDocDownload.setTitle(this.downloadFileName("ABN-Form"));

		// Save the readonly version for download
		this.pdfABNBytesDownLoad = await this.pdfDocDownload.save();
	}
	rasterizeCanvas(clonedForm: HTMLElement, formioElement: any) {
		const originalCanvases = formioElement.querySelectorAll("canvas");
		const clonedCanvases = clonedForm.querySelectorAll("canvas");

		originalCanvases.forEach((originalCanvas: any, index: any) => {
			const dataUrl = originalCanvas.toDataURL("image/png");

			const img = document.createElement("img");
			img.src = dataUrl;
			img.style.width = "530px";
			img.style.height = "150px";

			const clonedCanvas = clonedCanvases[index];
			clonedCanvas.replaceWith(img);
		});
		return clonedForm;
	}

	fixImgUrls(clonedForm: any){
		var paymentInfoCmp = clonedForm.querySelector('.formio-component-paymentInfo');

		if(!paymentInfoCmp){
			return;
		}

		var fileComponents = paymentInfoCmp.querySelectorAll('.formio-component-file');
		fileComponents.forEach((fileComponent: any) => {
			var container = fileComponent.closest('[ref^="column-"]') || fileComponent.parentElement;
			
			if (!container) {
				return;
			}
			var linkElement = container.querySelector('.formio-component-htmlelement a[href]');
			
			var imgElement = fileComponent.querySelector('img[ref="fileImage"]');
			
			if (linkElement && imgElement) {
				var freshUrl = linkElement.getAttribute('href');
				if (freshUrl) { 
                	imgElement.setAttribute('src', freshUrl);
            	}
			}
			
		});

	}

	private async saveFormSnapshot(): Promise<void> {

		const components = this.form?.root?.components?.[0]?.components;
		if (!components) return;
		
		this.headerIntake = {
			firstName: this.formData.data.firstName,
			lastName: this.formData.data.lastName,
			birthDate: this.formatDate(this.formData.data.day),
			chiroLabel: this.formData.data.chiroLabel,
			printedOn: this.formatToCST(new Date()),
		};
		this.loadingService.show();
		const expandedIndex = components.findIndex((comp: any) => comp.collapsed === false);

		//this is a logic after the collapse/expansion already happens
		
		components.forEach((comp: any, i: number) => {
			comp.collapsed = false;
		});
		this.form.redraw();

		await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
		await new Promise((res) => setTimeout(res, 1000));

		const formioElement = document.querySelector(".formio-form") as any;

		await this.waitForSVGs(formioElement);
		await new Promise((res) => setTimeout(res, 2800));

		var clonedForm = formioElement.cloneNode(true) as HTMLElement;


		clonedForm = this.rasterizeCanvas(clonedForm, formioElement);

		this.fixImgUrls(clonedForm);
		
		// await this.convertImagesToBase64(clonedForm);
		clonedForm.querySelectorAll("button").forEach((btn) => btn.remove());
		clonedForm.querySelectorAll(".text-checkbox").forEach(el => el.remove());
		clonedForm.querySelectorAll("textarea").forEach((textarea) => {
			const div = document.createElement("div");

			// Copy over attributes except style
			for (const { name, value } of Array.from(textarea.attributes)) {
				if (name !== "style") {
					div.setAttribute(name, value);
				}
			}

			// Preserve the text content
			div.textContent = textarea.value;

			// Optionally, give it a style to look like a normal text block
			div.style.whiteSpace = "pre-wrap"; // preserves line breaks
			div.style.overflowY = "visible"; // ensure it's not clipped
			div.style.height = "auto"; // let it grow naturally

			// Replace textarea in DOM
			textarea.replaceWith(div);
		});
		const cssContent = await this.http.get('assets/print-styles.css', { 
            responseType: 'text' 
        }).toPromise();
        
        const styles = `
            <style>
                ${cssContent}
            </style>
            ${Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
                .map((el) => el.outerHTML)
                .join("\n")}
        `;

		clonedForm.querySelectorAll("input, textarea, select").forEach((el: any) => {
			if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
				el.setAttribute("value", el.value);
			} else if (el.tagName === "SELECT") {
				// mark selected option
				Array.from(el.options).forEach((opt: any) => {
					if (opt.selected) opt.setAttribute("selected", "selected");
					else opt.removeAttribute("selected");
				});
			}
		});
		//body image canvas + svg rendering
		await this.fixCanvasAndSVGPositions(clonedForm);

		// Apply display:inline-block to ALL <a> tags inside the consent checkbox label, ONLY in the snapshot.
		// This handles both new-consent links (.consent-link class) AND legacy default links
		// (e.g. old patients without scribe consent) that don't have the consent-link class.
		clonedForm.querySelectorAll('.formio-component-consentOfPrivacyInformedAA a, a.consent-link').forEach((linkEl: Element) => {
			(linkEl as HTMLAnchorElement).style.display = 'inline-block';
		});

		// Strip unanswered fields so blank questions don't appear on the downloaded PDF.
		this.removeEmptyFieldsFromSnapshot(clonedForm);

		this.savedFormHtml = clonedForm.outerHTML;
		this.savedStyles = styles;

		components.forEach((comp: any, i: number) => {
			comp.collapsed = i !== expandedIndex || 0; // collapse others, expand clicked
		});
		this.loadingService.hide();
		this.attachCardClickListeners(this.form);
	}

	// Strips unanswered fields (and empty section info) from the PDF snapshot clone
	private removeEmptyFieldsFromSnapshot(clonedForm: HTMLElement): void {
		const root: any = this.form;
		if (!root || typeof root.everyComponent !== "function") {
			return;
		}

		// Field types removed when empty
		const removableTypes = new Set([
			"textfield",
			"textarea",
			"number",
			"email",
			"phoneNumber",
			"url",
			"currency",
			"datetime",
			"day",
			"time",
			"select",
			"tags",
		]);

		const submissionData = this.formData?.data ?? root.submission?.data ?? {};

		// Read a (possibly nested) value out of the submission data by path
		const getByPath = (obj: any, path: string): any => {
			if (!obj || !path) return undefined;
			return path
				.replace(/\[(\d+)\]/g, ".$1")
				.split(".")
				.reduce((acc: any, part: string) => (acc == null ? acc : acc[part]), obj);
		};

		const deepFind = (obj: any, key: string): any => {
			if (!obj || typeof obj !== "object") return undefined;
			if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
			for (const k of Object.keys(obj)) {
				const v = obj[k];
				if (v && typeof v === "object") {
					const found = deepFind(v, key);
					if (found !== undefined) return found;
				}
			}
			return undefined;
		};

		// Empty = null/undefined, blank string, empty array, or all-false/empty object (selectboxes)
		const isValueEmpty = (value: any): boolean => {
			if (value === undefined || value === null) return true;
			if (typeof value === "boolean") return value === false; // unchecked checkbox = empty
			if (typeof value === "string") return value.trim() === "";
			if (Array.isArray(value)) return value.length === 0;
			if (typeof value === "object") {
				const vals = Object.values(value);
				if (vals.length === 0) return true;
				if (vals.every((v) => v === false || v === null || v === undefined || v === "")) return true;
				return false;
			}
			return false; 
		};

		// True if the rendered clone element shows a value
		// Detection is DOM-based because dataValue/submission-data are unreliable for Choices selects and display-only fields
		const hasRenderedValue = (el: Element): boolean => {
			// Selected Choices chip (single/multiple) - not the dropdown option list;
			// skip placeholder
			const chips = el.querySelectorAll(
				".choices__list--single .choices__item, .choices__list--multiple .choices__item"
			);
			for (let i = 0; i < chips.length; i++) {
				const chip = chips[i] as HTMLElement;
				if (chip.classList.contains("choices__placeholder")) continue;
				if (chip.getAttribute("data-placeholder") === "true") continue;
				const dvAttr = chip.getAttribute("data-value");
				if (dvAttr !== null && dvAttr.trim() === "") continue; // empty data-value = placeholder
				const text = (chip.textContent || "").trim();
				if ((dvAttr && dvAttr.trim()) || text) return true;
			}

			const selects = el.querySelectorAll("select");
			for (let i = 0; i < selects.length; i++) {
				const sel = selects[i] as HTMLSelectElement;
				if (sel.closest(".choices")) continue;
				const opt = sel.options[sel.selectedIndex];
				if (opt && (opt.value || "").trim()) return true;
			}
			// Text inputs (skip checkbox/radio/hidden and the Choices search box)
			const inputs = el.querySelectorAll(
				"input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not(.choices__input)"
			);
			for (let i = 0; i < inputs.length; i++) {
				const inp = inputs[i] as HTMLInputElement;
				const v = (inp.getAttribute("value") ?? inp.value ?? "").trim();
				if (v) return true;
			}
			// Textareas 
			const tas = el.querySelectorAll("textarea, [ref='input'].form-control, .formio-editor-read-only-content");
			for (let i = 0; i < tas.length; i++) {
				const node = tas[i] as HTMLElement;
				const val = ((node as HTMLTextAreaElement).value || node.textContent || "").trim();
				if (val) return true;
			}
			return false;
		};

		const esc = (k: string) => ((window as any).CSS?.escape ? CSS.escape(k) : k);

		// Fields/sections tagged with one of these custom classes are ALWAYS kept on the pdf whether filled or not
		// show-on-pdf-longer -> intakeform, show-on-pdf-shorter -> intakev20.
		const ALWAYS_ON_PDF_CLASSES = ["show-on-pdf-longer", "show-on-pdf-shorter"];

		// A conditionally-hidden component stays in the clone as .formio-hidden
		// It must NOT be kept even if tagged, so that mutually-exclusive fields (e.g. the two Birth Date variants) don't both print
		const isHiddenEl = (el: Element): boolean =>
			!!el.closest(".formio-hidden") ||
			/display\s*:\s*none/i.test((el as HTMLElement).getAttribute("style") || "");

		// True when the element itself carries an always-on class, or contains a descendant that does
		// (so a section survives if it holds any always-on field) — but only counting VISIBLE ones
		const keepAlways = (el: Element): boolean =>
			ALWAYS_ON_PDF_CLASSES.some((cls) => {
				if (el.classList.contains(cls)) return !isHiddenEl(el);
				const tagged = el.querySelectorAll(`.${cls}`);
				for (let i = 0; i < tagged.length; i++) {
					if (!isHiddenEl(tagged[i])) return true;
				}
				return false;
			});

		const isSignatureEmpty = (v: any): boolean => {
			if (isValueEmpty(v)) return true;
			if (typeof v === "string" && v.startsWith("data:image")) return v.length < 2500;
			return false;
		};

		// True if a sketchpad (figure) inside 'scope' actually has strokes drawn on it
		const hasSketchDrawing = (scope: Element): boolean =>
			!!scope.querySelector(
				".formio-sketchpad-canvas svg path, .formio-sketchpad-canvas svg polyline, .formio-sketchpad-canvas svg line, .formio-sketchpad-canvas svg circle, .formio-sketchpad-canvas svg ellipse, .formio-sketchpad-canvas svg polygon"
			);

		const subtreeHasValue = (comp: any, scopeEl?: Element): boolean => {
			const domRoot: ParentNode = scopeEl || clonedForm;
			let found = false;
			const visit = (c: any) => {
				if (found) return;
				const d = c?.component;
				if (!d || d.input !== true || d.type === "button") return;
				if (d.hidden === true || c.visible === false) return;
				const el = d.key ? domRoot.querySelector(`.formio-component-${esc(d.key)}`) : null;
				if (d.type === "checkbox") {
					// Only a checked checkbox keeps its group/info (unchecked ones are removed).
					// Prefer the scoped DOM; fall back to data only when this field is rendered here.
					const cb = el?.querySelector("input[type=checkbox]") as HTMLInputElement | null;
					if (cb && (cb.checked || cb.hasAttribute("checked") || cb.getAttribute("aria-checked") === "true")) {
						found = true;
					} else if (el && getByPath(submissionData, c.path || d.key) === true) {
						found = true;
					}
					return;
				}
				if (Array.isArray(c.components) && c.components.length > 0) return;
				// Sketchpad counts only when something is drawn
				if (el && el.querySelector(".formio-sketchpad-container")) {
					if (hasSketchDrawing(el)) found = true;
					return;
				}
				// Signature counts only when actually signed (not a blank/cleared one)
				if (d.type === "signature") {
					if (el) {
						const img = el.querySelector('img[ref="signatureImage"]') as HTMLImageElement | null;
						let v = getByPath(submissionData, c.path || d.key);
						if (v === undefined) v = deepFind(submissionData, d.key);
						if ((img && !isSignatureEmpty(img.getAttribute("src"))) || !isSignatureEmpty(v)) found = true;
					}
					return;
				}
				// File counts only when something was uploaded (rendered inside this section)
				if (d.type === "file") {
					if (el && el.querySelector('img[ref="fileImage"]')) found = true;
					return;
				}
				// Ordinary fields: trust the section-scoped rendered DOM, not the shared data model.
				if (el && hasRenderedValue(el)) found = true;
			};
			visit(comp);
			if (!found && typeof comp.everyComponent === "function") comp.everyComponent(visit);
			return found;
		};

		// Pass 1 — remove empty leaf fields (label goes with them): empty text/select/etc,
		root.everyComponent((component: any) => {
			try {
				const def = component?.component;
				if (!def || def.input !== true || !def.key) return;
				if (Array.isArray(component.components) && component.components.length > 0) return;

				// Checkboxes - show only checked ones
				if (def.type === "checkbox") {
					if (getByPath(submissionData, component.path || def.key) === true) return;
					clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
						if (keepAlways(el)) return;
						const cb = el.querySelector("input[type=checkbox]") as HTMLInputElement | null;
						const domChecked = !!cb && (cb.checked || cb.hasAttribute("checked") || cb.getAttribute("aria-checked") === "true");
						if (!domChecked) el.remove();
					});
					return;
				}

				// File/upload - remove when nothing was uploaded
				// keep uploaded files (image + their download link)
				if (def.type === "file") {
					let v = getByPath(submissionData, component.path || def.key);
					if (v === undefined) v = deepFind(submissionData, def.key);
					if (!isValueEmpty(v)) return;
					clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
						if (keepAlways(el)) return;
						if (el.querySelector('img[ref="fileImage"]')) return;
						el.remove();
					});
					return;
				}

				if (!removableTypes.has(def.type)) return;

				clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
					if (keepAlways(el)) return;
					if (!hasRenderedValue(el)) el.remove();
				});
			} catch (err) {
				console.warn("removeEmptyFieldsFromSnapshot: skipped a component", err);
			}
		});

		// Pass 2 — remove unsigned signatures and sketchpads with nothing drawn.
		root.everyComponent((component: any) => {
			try {
				const def = component?.component;
				if (def?.type === "signature" && def.input === true && def.key) {
					let sigVal = getByPath(submissionData, component.path || def.key);
					if (sigVal === undefined) sigVal = deepFind(submissionData, def.key);
					if (!isSignatureEmpty(sigVal)) return; // signed → keep
					clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
						if (keepAlways(el)) return;
						const img = el.querySelector('img[ref="signatureImage"]') as HTMLImageElement | null;
						if (img && !isSignatureEmpty(img.getAttribute("src"))) return; // signed → keep
						el.remove();
					});
				}
			} catch (err) {
				console.warn("removeEmptyFieldsFromSnapshot: skipped a signature", err);
			}
		});
		clonedForm.querySelectorAll(".formio-sketchpad-container").forEach((container) => {
			if (hasSketchDrawing(container)) return;
			const target = container.closest(".formio-component") || container;
			if (keepAlways(target)) return;
			target.remove();
		});

		// Pass 2.5 - EditGrids - remove empty rows and the entire grid if nothing remains
		clonedForm.querySelectorAll(".formio-component-editgrid").forEach((grid) => {
			try {
				if (keepAlways(grid)) return;
				grid
					.querySelectorAll(".list-group-item.list-group-header, li.list-group-header")
					.forEach((h) => h.remove());

				const rows = Array.from(grid.querySelectorAll("li.list-group-item")) as HTMLElement[];

				let keptRows = 0;
				rows.forEach((row) => {
					row.querySelectorAll("tr").forEach((tr) => {
						const cells = tr.querySelectorAll("td");
						if (cells.length < 2) return; // not a label/value field row
						const valueCell = cells[cells.length - 1];
						if ((valueCell.textContent || "").trim() === "") tr.remove();
					});
					// Row survives only if at least one field row with a value remains
					if (row.querySelector("tr td")) keptRows++;
					else row.remove();
				});

				if (keptRows === 0) grid.remove();
			} catch (err) {
				console.warn("removeEmptyFieldsFromSnapshot: skipped an editgrid", err);
			}
		});

		// Pass 3 - remove a container group (its visible label + body) when nothing visible is left inside it
		// kept if it still holds a (checked) checkbox, signed signature, drawn sketchpad, or any rendered value
		root.everyComponent((component: any) => {
			try {
				const def = component?.component;
				if (!def || def.type !== "container" || !def.key) return;
				clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
					if (keepAlways(el)) return;
					const keep =
						el.querySelector(".formio-component-checkbox, .formio-component-signature, .formio-sketchpad-container") ||
						el.querySelector('img[ref="fileImage"]') || // uploaded file/image (e.g. insurance card scans)
						hasRenderedValue(el);
					if (!keep) el.remove();
				});
			} catch (err) {
				console.warn("removeEmptyFieldsFromSnapshot: skipped a container", err);
			}
		});

		// Green info notes (infoComponent) - remove, unless tagged to always show on the PDF
		clonedForm.querySelectorAll(".formio-component-infoComponent").forEach((el) => {
			if (keepAlways(el)) return;
			el.remove();
		});

		// Pass 4 — hide an entire section (header + body) when nothing in it is answered
		const sectionTypes = new Set(["customPanel", "panel"]);
		root.everyComponent((component: any) => {
			try {
				const def = component?.component;
				if (!def || !sectionTypes.has(def.type) || !def.key) return;
				// Evaluate each rendered instance of the section against ITS OWN subtree, so a
				// same-keyed field filled in another section can't keep this one alive
				clonedForm.querySelectorAll(`.formio-component-${esc(def.key)}`).forEach((el) => {
					if (keepAlways(el)) return;
					if (!subtreeHasValue(component, el)) el.remove();
				});
			} catch (err) {
				console.warn("removeEmptyFieldsFromSnapshot: skipped a section", err);
			}
		});
	}

	private waitForSVGs(comp: any): Promise<void> {
		return new Promise((resolve) => {
			const check = () => {
				const svgs = Array.from(comp.querySelectorAll("svg")) as SVGSVGElement[];
				const allRendered = svgs.every((svg: SVGSVGElement) => {
					// crude check: ensure it has at least one child (path, g, etc.)
					return svg.querySelector("*") !== null;
				});

				if (allRendered) {
					resolve();
				} else {
					requestAnimationFrame(check);
				}
			};
			check();
		});
	}

	/**
	 * Get all forms that need to be downloaded
	 */

	async addDownloadABN() {
		if (
			!this.availableForms.some((x) => x.name === "ABN-Form") &&
			this.formData?.data?.abnNestedForm.data.signatureAbn &&
			this.formData?.data?.abnNestedForm.data.dateTime &&
			this.formData?.data.isPatinetCoveredByInsurance === "Medicare"
		) {
			this.tabs[TabEnum.ABN].downloadable = true;
			this.availableForms.push({
				name: "ABN-Form",
				formId: "",
				submissionId: "",
			});
			this._showABNForm = true;
			// await this.renderABNForm();
		}
	}

	addDownloadIntakeForm() {
		if (this.formData) {
			const mainFormId = this.formData.form || "";
			const mainSubmissionId = this.formData._id || this.submissionId || "";

			if (
				mainFormId &&
				mainSubmissionId &&
				!this.availableForms.some((x) => x.name === "Intake-Form")
			) {
				this.availableForms.push({
					name: "Intake-Form",
					formId: mainFormId,
					submissionId: mainSubmissionId,
				});
			}
		}
	}

	//  method to load the submission and on refresh use the hash-based URL format
	private async loadExistingSubmission() {
		const wasRefresh = sessionStorage.getItem(`is_refreshing_${this.submissionId}`);
		if (wasRefresh) {
			console.log("🛡️ Recovered from refresh. Keeping the existing lock.");
			sessionStorage.removeItem(`is_refreshing_${this.submissionId}`);
		}
		try {
			console.log("Entering load exsiting submission")
			// Check if we're opening in readonly mode from query params
			let isReadOnly = this.isReadOnly;

			// Get current user's ID for verification
			const currentUser = this.authService.getUserData();
			const currentUserId = currentUser?._id;
			const currentUserName = currentUser
				? `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim()
				: "";

			// Check if this submission is already open in another tab by this user
			if (currentUserId && this.submissionId && !isReadOnly) {
				const lockInfo = this.tabTrackingService.isLockedByCurrentUserInAnotherTab(
					this.submissionId,
					currentUserId
				);

				if (lockInfo) {
					// This submission is already being edited by this user in another tab
					console.warn("This submission is already being edited by you in another tab.");

					this.isOpenInAnotherTab = true;
					this.otherTabOpenTime = lockInfo.timestamp;

					// Force readonly mode
					isReadOnly = true;

					// IMPORTANT: Use hash-based URL with /new-intake path instead of /patients/intake
					const url = `${window.location.origin}/#/new-intake/${this.submissionId}?mode=readonly`;
					window.history.replaceState({}, "", url);
				}
			}

			this.formData = await this.patientService.getSubmission(
				this.submissionId!,
				"readonly"
			);
			this.initialLockDateTime = this.formData?.data?.lockDateTime || null;
			console.log("Initial date time lock: ", this.initialLockDateTime);

			this.captureServerFingerprint(this.formData);

			this.captureInitialInsuranceInfo();

			// If we're not in readonly mode, check lock status before acquiring edit lock
			if (!isReadOnly && !this.isOpenInAnotherTab) {
				this.formData = await this.patientService.getSubmission(this.submissionId!, "edit");
				const isLockedPreCheck =
				this.formData?.data?.locked === true || this.formData?.data?.locked === "true";
				const lockedByIdPreCheck = this.formData?.data?.lockedById?.toString();
				const currentUserIdStr = currentUserId?.toString();
				const lockedByNamePreCheck = this.formData?.data?.lockedBy || "";
				const isSameUserById = currentUserIdStr && lockedByIdPreCheck && currentUserIdStr === lockedByIdPreCheck;
				const isSameUserByName = lockedByNamePreCheck === currentUserName;

				console.group("Form Lock Debug - Initial Check");
				console.log("1. Current User:", { id: currentUserIdStr, name: currentUserName });
				console.log("2. DB Values (EDIT):", { 
					locked: this.formData?.data?.locked, 
					lockedBy: this.formData?.data?.lockedBy, 
					lockedById: this.formData?.data?.lockedById,
					lockDateTime: this.formData?.data?.lockDateTime 
				});

				// Only acquire edit lock if not locked by another user
				if (!isLockedPreCheck || isSameUserById || isSameUserByName) {
					console.log("Not locked by another user")
				} else {
					console.log("Locked by another user")
					// Locked by another user - stay in readonly mode
					isReadOnly = true;
				}
			}

			// Update patient name if available
			if (this.formData?.data?.firstName && this.formData?.data?.lastName) {
				this.patientName = `${this.formData.data.firstName} ${this.formData.data.lastName}`;
			}

			// Fix for when the locked by user is the same as current user
			if (
				this.formData?.data?.locked &&
				this.formData?.data?.lockedBy &&
				this.formData?.data?.lockedBy === currentUserName
			) {
				if (!isReadOnly) {
					this.isLockedByOtherUser = false;
				}
			}

			// Check if submission is locked by another user
			const isLocked =
				this.formData?.data?.locked === true || this.formData?.data?.locked === "true";

			if (isLocked) {
				// Get current user's ID
				const currentUserId = currentUser?._id;

				// Get the ID of user who locked it
				const lockedById = this.formData?.data?.lockedById;

				// Convert both IDs to string for comparison (if they exist)
				const lockedByIdStr = lockedById?.toString();
				const currentUserIdStr = currentUserId?.toString();

				// Get the name of the user who locked it
				const lockedByName = this.formData?.data?.lockedBy || "another user";

				// Check if the current user is the one who locked the form
				const isSameUser = currentUserIdStr && lockedByIdStr && currentUserIdStr === lockedByIdStr;

				// Handle case when current user is not the same as who locked it
				if (!isSameUser && lockedByName !== `${currentUser?.firstName} ${currentUser?.lastName}`) {
					console.warn("This submission is locked by another user. Forcing readonly mode.");

					// Check if this user previously had a lock in localStorage (they were taken over)
					// Clean up the stale localStorage entry
					if (this.submissionId) {
						this.tabTrackingService.forceReleaseLock(this.submissionId);
					}

					// Store lock info for display
					this.lockedByUser = lockedByName;
					this.lockedByDate = this.formData?.data?.lockDateTime || "";
					this.isLockedByOtherUser = true;

					// Force readonly mode
					isReadOnly = true;
					this.renderForm();
				} else if (!isReadOnly && !this.isOpenInAnotherTab) {
					// submission is locked by the current user (normal edit mode)
					// only register if this tab is actually entering edit mode
					if (currentUserId && this.submissionId) {
						this.tabTrackingService.registerLock(this.submissionId, currentUserId);
						localStorage.setItem(`activeTabId_${this.submissionId}`, this.tabInstanceId);
					}
				}
			} else if (!isReadOnly && !this.isOpenInAnotherTab) {
				// not locked and not in readonly mode, register this tab as the owner of the lock
				if (currentUserId && this.submissionId) {
					this.tabTrackingService.registerLock(this.submissionId, currentUserId);
					localStorage.setItem(`activeTabId_${this.submissionId}`, this.tabInstanceId);
				}
			}

			// Update the component's readonly flag to match our determination
			this.isReadOnly = isReadOnly;

			// Setup cross-tab listener so this tab gets notified if another tab takes over
			if (!this.isReadOnly && !this.isLockedByOtherUser) {
				this.setupCrossTabListener();
			}
		} catch (error: any) {
			console.error("Error loading submission:", error);

			// Check if the error is due to authentication
			if (error.status === 401) {
				// Let the interceptor handle the logout and redirect
				throw error;
			}

			// For other errors, provide user feedback
			throw new Error(`Failed to load patient data: ${error.message || "Unknown error"}`);
		}
	}

	/**
	 * Render the FormIO form with appropriate settings
	 */
	private async renderForm() {
		try {
			console.log("Form ", this.formData?.form)
			const formPath = this.getFormPathByFormId(this.formData?.form);
			
			// Get form schema
			let formSchema = await Formio.request(`${environment.PROJECT_URL}/${formPath}`, "GET");

			// Get form container
			const formContainer = document.getElementById("formio");
			if (!formContainer) {
				throw new Error("Form container not found");
			}
			let readOnlyStatus = this.isReadOnly || false;

			await this.renderExistingForm(formContainer, formSchema, readOnlyStatus);
		} catch (error: any) {
			console.error("Error rendering form:", error);
			throw new Error(`Failed to render form: ${error.message || "Unknown error"}`);
		}
	}

	async saveAASnapshotNew() {
		this.pdfBytesAASnapshot = await this.drawValuesOnPdf(
			"assets/agreements_template2.pdf",
			null,
			[
				{
					text: this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 370,
					y: 720,
					page: 0,
				},
				// {
				// 	text:  this.formData.data.firstName + " " + this.formData.data.lastName,
				// 	x: 300,
				// 	y: 770,
				// 	page: 1,
				// },
				{ text: this.formData.data.patientSignature, x: 80, y: 55, page: 0 },
				{ text: this.formatDate(this.formData.data.date2), x: 470, y: 60, page: 0 },
				// { text: this.formData.data.signature, x: 80, y: 360, page: 2 },
				// { text: this.formatDate(this.formData.data.date), x: 430, y: 360, page: 2 },
			],
			null
		);
	}
	async saveAASnapshot() {
		this.pdfBytesAASnapshot = await this.drawValuesOnPdf(
			"assets/agreements_template.pdf",
			null,
			[
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 0,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 1,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 2,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 470, page: 2 },
				{ text: this.formData.data.signature, x: 80, y: 360, page: 2 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 470, page: 2 },
				{ text: this.formatDate(this.formData.data.date), x: 430, y: 360, page: 2 },
			],
			null
		);
	}
	async saveInformedConsentSnapshotNew() {
		this.pdfBytesSnapshot = await this.drawValuesOnPdf(
			"assets/informed_consent_template2.pdf",
			null,
			[	
				{
				text: this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 370,
				y: 720,
				page: 0,
				},
				{
					text:  this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 370,
					y: 720,
					page: 1,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 410, page: 1 },
				{ text: this.formData.data.signature, x: 80, y: 360, page: 1 },
				{ text: this.formatDate(this.formData.data.date2), x: 455, y: 410, page: 1 },
				{ text: this.formatDate(this.formData.data.date), x: 455, y: 360, page: 1 },
				]
		);
	}
	async saveInformedConsentSnapshot() {
		this.pdfBytesSnapshot = await this.drawValuesOnPdf(
			"assets/informed_consent_template.pdf",
			null,
			[
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 0,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 1,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 2,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 480, page: 2 },
				{ text: this.formData.data.signature, x: 80, y: 370, page: 2 },
				{ text: this.formatDate(this.formData.data.date2), x: 455, y: 480, page: 2 },
				{ text: this.formatDate(this.formData.data.date), x: 455, y: 370, page: 2 },
			]
		);
	}

	async saveTextConsentSnapshot() {
		this.pdfTextBytesSnapshot = await this.drawValuesOnPdf("assets/sms_consent.pdf", null, [
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 0,
			},
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 1,
			},
			{ text: this.formData.data.patientSignature, x: 90, y: 190, page: 1 },
			{ text: this.formatDate(this.formData.data.date2), x: 410, y: 190, page: 1 },
		]);
	}
	async saveCCOFSnapshot() {
		this.pdfBytesCCOFSnapshot = await this.drawValuesOnPdf(
			"assets/ccof_template.pdf",
			null,
			[
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 0,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 1,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 485, page: 1 },
				{ text: this.formData.data.signature, x: 80, y: 355, page: 1 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 485, page: 1 },
				{ text: this.formatDate(this.formData.data.date), x: 430, y: 355, page: 1 },
			],
			null
		);
	}

	async saveScribeSnapshot() {
    if (!this.showScribe) return;

    const data = this.formData.data;
    let templatePath = "";
    let currentY = 0;

    if (data.IsNewScribeConsent === true) {
        templatePath = "assets/scribe_template_new.pdf";
        currentY = 368; 
    } 
    else if (data.IsScribeConsent === true) {
        templatePath = "assets/scribe_template.pdf";
        currentY = 385;
    } 
    else {
        return;
    }

    this.pdfScribeBytesSnapshot = await this.drawValuesOnPdf(
        templatePath,
        null,
        [
            {
                text: data.firstName + " " + data.lastName,
                x: 360,
                y: 700,
                page: 0,
            },
            { 
                text: data.patientSignature, 
                x: 80, 
                y: currentY, 
                page: 0 
            },
            { 
                text: this.formatDate(data.date2), 
                x: 430, 
                y: currentY, 
                page: 0 
            },
        ],
        null
    );
}

	async saveNOPPSnapshot() {
		this.pdfBytesNOPPSnapshot = await this.drawValuesOnPdf(
			"assets/receipt_of_nopp.pdf",
			null,
			[
				{
					text: this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 350,
					y: 700,
					page: 0,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 425, page: 0 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 425, page: 0 },
			],
			null
		);
	}

	async renderAATabNew(show = false) {
		if (!this._showAATab && !show) {
			return;
		}
		this.pdfBytesAA = await this.drawValuesOnPdf(
			"assets/agreements_template2.pdf",
			null,
			[
				{
					text: this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 370,
					y: 720,
					page: 0,
				},
				// {
				// 	text:  this.formData.data.firstName + " " + this.formData.data.lastName,
				// 	x: 300,
				// 	y: 770,
				// 	page: 1,
				// },
				{ text: this.formData.data.patientSignature, x: 80, y: 55, page: 0 },
				{ text: this.formatDate(this.formData.data.date2), x: 470, y: 60, page: 0 },
				// { text: this.formData.data.signature, x: 80, y: 360, page: 2 },
				// { text: this.formatDate(this.formData.data.date), x: 430, y: 360, page: 2 },
			],
			null
		);
		this.pdfSrcAA = new Uint8Array(this.pdfBytesAA!);
	}
	async renderAATab(show = false) {
		if (!this._showAATab && !show) {
			return;
		}
		this.pdfBytesAA = await this.drawValuesOnPdf(
			"assets/agreements_template.pdf",
			null,
			[
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 0,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 1,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 2,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 470, page: 2 },
				{ text: this.formData.data.signature, x: 80, y: 360, page: 2 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 470, page: 2 },
				{ text: this.formatDate(this.formData.data.date), x: 430, y: 360, page: 2 },
			],
			null
		);
		this.pdfSrcAA = new Uint8Array(this.pdfBytesAA!);
	}
		async renderCCOFTab(show = false) {
		if (!this._showCCOF && !show) {
			return;
		}
		this.pdfBytesCCOF = await this.drawValuesOnPdf(
			"assets/ccof_template.pdf",
			null,
			[
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 0,
				},
				{
					text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 300,
					y: 770,
					page: 1,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 485, page: 1 },
				{ text: this.formData.data.signature, x: 80, y: 355, page: 1 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 485, page: 1 },
				{ text: this.formatDate(this.formData.data.date), x: 430, y: 355, page: 1 },
			],
			null
		);
		this.pdfSrcCCOF = new Uint8Array(this.pdfBytesCCOF!);
	}

	async renderNOPPTab(show = false) {
		if (!this.showNOPP && !show) {
			return;
		}
		this.pdfBytesNOPP = await this.drawValuesOnPdf(
			"assets/receipt_of_nopp.pdf",
			null,
			[
				{
					text: this.formData.data.firstName + " " + this.formData.data.lastName,
					x: 350,
					y: 700,
					page: 0,
				},
				{ text: this.formData.data.patientSignature, x: 80, y: 425, page: 0 },
				{ text: this.formatDate(this.formData.data.date2), x: 430, y: 425, page: 0 },
			],
			null
		);
		this.pdfSrcNOPP = new Uint8Array(this.pdfBytesNOPP!);
	}

async renderScribeTab(show = false) {
    if (!this.showScribe && !show) {
        return;
    }

    const data = this.formData.data;
    let templatePath = "";
    let currentY = 0;

    if (data.IsNewScribeConsent === true) {
        templatePath = "assets/scribe_template_new.pdf";
        currentY = 368; 
    } 
    else if (data.IsScribeConsent === true) {
        templatePath = "assets/scribe_template.pdf";
        currentY = 385;
    } 
    else {
        return;
    }

    this.pdfScribeBytes = await this.drawValuesOnPdf(
        templatePath,
        null,
        [
            {
                text: data.firstName + " " + data.lastName,
                x: 360,
                y: 700,
                page: 0,
            },
            { 
                text: data.patientSignature, 
                x: 80, 
                y: currentY, 
                page: 0 
            },
            { 
                text: this.formatDate(data.date2), 
                x: 430, 
                y: currentY, 
                page: 0 
            },
        ],
        null
    );
	this.pdfScribeSrc = new Uint8Array(this.pdfScribeBytes!);
}

	async setSignatureDate(e: any) {
		if (!this.pdfDoc) {
			return;
		}
		// Block date changes only if form is FULLY locked (both signature and date in DB).
		// Old patients with signature but no date should still be able to add the date.
		if (this.isABNFormFullyLocked()) {
			return;
		}
		const input = e.target;
		this.abnForm.signatureDate = input.value;
		this.signatureDate = input.value;
		// Get the form
		const form = this.pdfDoc.getForm();
		form.getTextField("signatureDate").setText(this.formatDate(this.abnForm.signatureDate!) || "");

		this.pdfABNBytes = await this.pdfDoc.save();
		this.pdfABNSrc = new Uint8Array(this.pdfABNBytes!);
		this.renderABNForm();
	}


	private isUsingNewABNForm(): boolean {
		// New form if: marked as "new" OR not yet signed (new patient)
		const isNewABNForm = this.abnForm.abnFormVersion === "new";
		const isABNSigned = !!this.abnForm.signatureAbn;
		const result = !isABNSigned || isNewABNForm;
		return result;
	}

	// ABN form is fully locked only when BOTH signature and date are already saved in DB.
	// Old patients with only a signature (no date) can still edit to add the missing date.
	isABNFormFullyLocked(): boolean {
		const data = this.formData?.data?.abnNestedForm?.data;
		return !!(data?.signatureAbn && data?.dateTime);
	}

	mapABN() {
		if (this.formData.data.abnNestedForm?.data) {
			const tempNestedForm = this.formData.data.abnNestedForm.data;
			this.abnForm = {
				patientName: tempNestedForm.patientFullNameABN,
				physicalExams: tempNestedForm.physicalExaminationsandTests,
				physicalTherapy: tempNestedForm.physicalTherapy,
				xRays: tempNestedForm.x_Rays,
				signatureAbn: tempNestedForm.signatureAbn,
				billingAgreement: tempNestedForm.check1!!,
				notBillMedicare: tempNestedForm.check2!!,
				notBill: tempNestedForm.check3!!,
				careCost: tempNestedForm.costAbn ?? null,
				manipulativeTherapy: tempNestedForm.manipulativeTherapy,
				manipulativeTreatment: tempNestedForm.manipulativeTreatment,
				abnFormVersion: tempNestedForm.abnFormVersion,
				orthotics: tempNestedForm.equipment,
				signatureDate:
					tempNestedForm.dateTime == null || tempNestedForm.dateTime == ""
						? null
						: new Date(tempNestedForm?.dateTime?.replace(/Z$/, "")),
				notifier: this.formData.data.chiroLabel,
			};
		} else {
			this.abnForm = {
				physicalExams: true,
				manipulativeTherapy: true,
				manipulativeTreatment: true,
				physicalTherapy: true,
				orthotics: true,
				xRays: true,
				notBillMedicare: false,
				notBill: false,
				billingAgreement: false,
				careCost: null,
				signatureDate: null,
				signatureAbn: null,
				abnFormVersion: null,  // Will be set to "new" when they sign; stays null for old form
				patientName: "",
				notifier: this.formData.data?.chiroLabel,
			};
		}
	}


	async renderPIForm() {
		// Through loadTemplate, not a bare fetch, or Alaska would get the branded page
		// with the Alaska coordinates drawn on it
		const piPdfBytes = (await this.loadTemplate("assets/pi_template.pdf")).bytes;
		this.pdfPIDoc = await PDFDocument.load(piPdfBytes);
		const lastPageIndex = this.pdfPIDoc.getPages().length - 1;

		const patientName = (this.formData.data.firstName ?? "") + " " + (this.formData.data.lastName ?? "");
		const values: { text: string; x: number; y: number; page: number }[] = [
			{ text: patientName, x: 110, y: 120, page: lastPageIndex },
		];

		if (this.formData.data.date2) {
			values.push({ text: this.formatDate(this.formData.data.date2), x: 500, y: 120, page: lastPageIndex });
		}

		if (this.formData.data.patientSignature?.toString().startsWith("data:image/png")) {
			values.push({ text: this.formData.data.patientSignature, x: 330, y: 120, page: lastPageIndex });
		}

		const filledPdfBytes = await this.drawValuesOnPdf("assets/pi_template.pdf", null, values, this.pdfPIDoc);
		this.pdfPIBytes = filledPdfBytes!;
		this.pdfPISrc = new Uint8Array(this.pdfPIBytes);
	}

	async savePISnapshot() {
		await this.renderPIForm();
		this.pdfPIBytesSnapshot = this.pdfPIBytes;
	}

	async savePIForm(goToNextPage = false) {
		if (!this.validateSubscriberFields()) return;

		this.loadingService.show();

		await this.commitOpenGridRows();

		await this.beginManualSave();
		const canSave = await this.checkLockAndConflictsBeforeSave();
		if (!canSave) {
			this.endManualSave();
			this.loadingService.hide();
			return;
		}

		this.formData.data.localStatus = "Intake Form-Submitted";
		this.form.submission = this.formData;
		await this.saveFormSnapshot();
		await this.savePISnapshot();
		this.patientService
			.updateSubmission(this.submissionId!, this.form.submission)
			.then(async (response) => {
				await this.saveFormSnapshot();
				if (this.formData.data.IsNewConsent) {
					await this.saveAASnapshotNew();
					await this.saveInformedConsentSnapshotNew();
					await this.saveNOPPSnapshot();
				} else {
					await this.saveAASnapshot();
					await this.saveInformedConsentSnapshot();
					await this.saveTextConsentSnapshot();
					await this.saveCCOFSnapshot();
				}
				await this.saveScribeSnapshot();
				if (this.showPITab) {
					await this.savePISnapshot();
				}
				await this.sendInsuranceImagesIfChanged();
				this.showDownloadDropdown();
				await this.renderPIForm();

				this.loadingService.hide();
				this.showMessage("Form saved successfully");
				if (goToNextPage) {
					if (this.showPITab) {
						const piTab = document.getElementById("pi-tab");
						if (piTab) piTab.click();
					} else {
						this.goToConsentForms();
					}
				}
			})
			.catch((error: any) => {
				console.error("Submission update error:", error);
				this.showError(`Failed to update submission: ${error.message || "Unknown error"}`);
				this.loadingService.hide();
			})
			.finally(() => this.endManualSave());
	}

	goBackFromPI(): void {
		if (this.getABNTab) {
			const abnTab = document.getElementById("abn-tab");
			if (abnTab) abnTab.click();
		} else {
			this.goToIntakeForm();
		}
	}


	async renderABNForm(updateDownload = false) {
		if (updateDownload || Object.keys(this.abnForm).length === 0) {
			this.mapABN();
		}
	
		let existingpdfBytes: ArrayBuffer | Uint8Array;
		const isUsingNewABNForm = this.isUsingNewABNForm();
		console.log("Is new form ? : " ,isUsingNewABNForm)

		if (this.pdfABNBytes) {
			existingpdfBytes = this.pdfABNBytes;
		} else {
			// Determine which PDF template to load based on form version
			const pdfFileName = isUsingNewABNForm ? "assets/ABN_Editable_New.pdf" : "assets/ABN_Editable.pdf";
			existingpdfBytes = await fetch(pdfFileName).then((res) => res.arrayBuffer());
		}

		this.pdfDoc = await PDFDocument.load(existingpdfBytes);
		this.pdfDoc.setTitle(this.downloadFileName("ABN-Form"));
		this.pdfDoc.registerFontkit(fontkit);
		const unicodeFont = await this.pdfDoc.embedFont(this._fontBytes!);

		// Get the form
		const form = this.pdfDoc.getForm();

		const fields = form.getFields();

		fields.forEach(field => {
		const type = field.constructor.name;
		const name = field.getName();
		console.log(`${type}: ${name}`);
		});

		this.signaturePdfService.setCheckBox(
			this.abnForm.manipulativeTherapy == null ? true : this.abnForm.manipulativeTherapy,
			form,
			"manipulativeTherapy"
		);
		// manipulativeTreatment field only exists on new ABN form
		if (isUsingNewABNForm) {
			this.signaturePdfService.setCheckBox(
				this.abnForm.manipulativeTreatment == null ? true : this.abnForm.manipulativeTreatment,
				form,
				"manipulativeTreatment"
			);
		}
		this.signaturePdfService.setCheckBox(
			this.abnForm.xRays == null ? true : this.abnForm.xRays,
			form,
			"xRays"
		);
		this.signaturePdfService.setCheckBox(
			this.abnForm.physicalExams == null ? true : this.abnForm.physicalExams,
			form,
			"physicalExams"
		);
		this.signaturePdfService.setCheckBox(
			this.abnForm.physicalTherapy == null ? true : this.abnForm.physicalTherapy,
			form,
			"physicalTherapy"
		);
		this.signaturePdfService.setCheckBox(
			this.abnForm.orthotics == null ? true : this.abnForm.orthotics,
			form,
			"orthotics"
		);
		this.signaturePdfService.setCheckBox(
			this.abnForm.billingAgreement ?? false,
			form,
			"billingAgreement"
		);
		this.signaturePdfService.setCheckBox(
			this.abnForm.notBillMedicare ?? false,
			form,
			"notBillMedicare"
		);
		this.signaturePdfService.setCheckBox(this.abnForm.notBill ?? false, form, "notBill");

		form
			.getTextField("careCost")
			.setText(this.abnForm?.careCost != null ? String(this.abnForm.careCost) : "");
		const dateField = form.getTextField("signatureDate");
		if (this.abnForm?.signatureDate) {
			// this.abnForm.signatureDate = new Date(this.abnForm?.signatureDate);
			dateField.setText(this.formatDate(this.abnForm?.signatureDate!) ?? "");
			this.signatureDate = this.formatDateDashed(this.abnForm.signatureDate);
		}
		dateField.enableReadOnly();

		await this.renderSignatureOnPDF();

		// prepopulate the full name, and disable it
		const fullNameField = form.getTextField("patientName");
		fullNameField.setText(this.formData.data.firstName + " " + this.formData.data.lastName);
		fullNameField.enableReadOnly();
		fullNameField.updateAppearances(unicodeFont);

		//dropdown logic for chiro center
		const dropdown = form.getDropdown("notifier");
		var options = dropdown.getOptions() || [];

		// Add new option to dropdown
		options = [...options, this.abnForm.notifier ?? ""];
		dropdown.setOptions(options || []);
		dropdown.select(this.abnForm.notifier ?? "");
		dropdown.enableReadOnly();

		setTimeout(() => {
			const container = document.querySelector(".ng2-pdf-viewer-container") || document.body;
			container.addEventListener("change", async (event: Event) => {
				const abnPane = document.querySelector("#abn-pane");
				if (!abnPane?.classList.contains("active")) return;

				const target = event.target as HTMLInputElement;
				const form = this.pdfDoc!.getForm();
				if (target && target.type === "text" && target.name === "careCost") {
					this.abnForm.careCost = String(target.value);
					form.getTextField("careCost").setText(target.value || "");
				}
				if (target && target.type === "checkbox") {
					// Only update abnForm for fields valid in current form type
					// manipulativeTreatment only exists on new ABN form
					if (target.name === "manipulativeTreatment" && !this.isUsingNewABNForm()) {
						return;
					}
					this.signaturePdfService.setCheckBox(target.checked, form, target.name);
					this.abnForm[target.name] = target.checked;
				}
			});
		}, 500);

		// Lock PDF fields only if form is FULLY locked (both signature and date in DB).
		// Old patients with signature but no date can still interact with the form to add the date.
		if (this.isReadOnly || this.isOpenInAnotherTab || this.isLockedByOtherUser || this.isABNFormFullyLocked()) {
			const fields = form.getFields();
			fields.forEach((field) => {
				field.enableReadOnly();
			});
		}
		this.pdfABNBytes = await this.pdfDoc.save();
		this.pdfABNSrc = new Uint8Array(this.pdfABNBytes!);

		if (updateDownload) {
			await this.createDownloadCopy(); // Use the new method
		}
	}

	normalize(str: string) {
		if (!str) return "";
		return str.toLowerCase().replace(/[^a-z0-9]/g, ""); // remove all non-alphanumeric characters
	}
	async renderInformedConsentNew(show = false) {
		if (!this._showInformedConsentTab && !show) {
			return;
		}
		this.pdfBytes = await this.drawValuesOnPdf("assets/informed_consent_template2.pdf", null, [
			{
				text: this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 370,
				y: 720,
				page: 0,
			},
			{
				text:  this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 370,
				y: 720,
				page: 1,
			},
			{ text: this.formData.data.patientSignature, x: 80, y: 410, page: 1 },
			{ text: this.formData.data.signature, x: 80, y: 360, page: 1 },
			{ text: this.formatDate(this.formData.data.date2), x: 455, y: 410, page: 1 },
			{ text: this.formatDate(this.formData.data.date), x: 455, y: 360, page: 1 },
		]);
		this.pdfSrc = new Uint8Array(this.pdfBytes!);
	}
	async renderConditionalInformedConsent(show = false){
		if (this.formData.data.IsNewConsent){
			await this.renderInformedConsentNew(show);
		} 
		else await this.renderInformedConsent(show); 
	}
	async renderConditionalAA(show = false){
		if (this.formData.data.IsNewConsent){
			await this.renderAATabNew(show);
		} 
		else await this.renderAATab(show); 
	}
	async renderInformedConsent(show = false) {
		if (!this._showInformedConsentTab && !show) {
			return;
		}
		this.pdfBytes = await this.drawValuesOnPdf("assets/informed_consent_template.pdf", null, [
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 0,
			},
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 1,
			},
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 2,
			},
			{ text: this.formData.data.patientSignature, x: 80, y: 480, page: 2 },
			{ text: this.formData.data.signature, x: 80, y: 370, page: 2 },
			{ text: this.formatDate(this.formData.data.date2), x: 455, y: 480, page: 2 },
			{ text: this.formatDate(this.formData.data.date), x: 455, y: 370, page: 2 },
		]);
		this.pdfSrc = new Uint8Array(this.pdfBytes!);
	}

	async renderPdfTextConsent(show = false) {
		if (!this._showTextConsentTab && !show) {
			return;
		}
		this.pdfTextBytes = await this.drawValuesOnPdf("assets/sms_consent.pdf", null, [
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 0,
			},
			{
				text: "Patient Name: " + this.formData.data.firstName + " " + this.formData.data.lastName,
				x: 300,
				y: 770,
				page: 1,
			},
			{ text: this.formData.data.patientSignature, x: 90, y: 190, page: 1 },
			{ text: this.formatDate(this.formData.data.date2), x: 410, y: 190, page: 1 },
		]);
		this.pdfTextSrc = new Uint8Array(this.pdfTextBytes!);
	}

	async renderMergedConsentForms(): Promise<void> {
		this.loadingService.show();

		try {
			if (this.formData.data.IsNewConsent) {
				await this.renderInformedConsentNew(true);
				await this.renderAATabNew(true);
				await this.renderScribeTab();
				await this.renderNOPPTab(true);
			} else {
				await this.renderInformedConsent(true);
				await this.renderAATab(true);
				if (this.showTextConsent) {
					await this.renderPdfTextConsent(true);
				}
				if (this.showCCOF) {
					await this.renderCCOFTab(true);
				}
				await this.renderScribeTab();
			}

			const consentPdfs: { bytes: Uint8Array | null, name: string }[] = [];

			if (this.pdfBytes) {
				consentPdfs.push({ bytes: new Uint8Array(this.pdfBytes), name: 'Informed Consent' });
			}

			if (this.pdfBytesAA) {
				consentPdfs.push({ bytes: new Uint8Array(this.pdfBytesAA), name: 'Payment Agreements & Authorizations' });
			}
			
			if (this.formData.data.IsNewConsent) {
				if (this.showNOPP && this.pdfBytesNOPP) {
					consentPdfs.push({ bytes: new Uint8Array(this.pdfBytesNOPP), name: 'Receipt of NOPP' });
				}
				if (this.showScribe && this.pdfScribeBytes) {
					consentPdfs.push({ bytes: new Uint8Array(this.pdfScribeBytes), name: ' State Biometric Privacy Laws' });
				}
				const { bytes: response } = await this.loadTemplate('assets/nopp.pdf');
				const noppPdfBytes =  new Uint8Array(response);
				consentPdfs.push({ bytes: noppPdfBytes, name: 'NOPP' });
			} else {
				if (this.showTextConsent && this.pdfTextBytes) {
					consentPdfs.push({ bytes: new Uint8Array(this.pdfTextBytes), name: 'Communications Consent' });
				}
				if (this.showCCOF && this.pdfBytesCCOF) {
					consentPdfs.push({ bytes: new Uint8Array(this.pdfBytesCCOF), name: 'Credit Card On File' });
				}
				if (this.showScribe && this.pdfScribeBytes) {
					consentPdfs.push({ bytes: new Uint8Array(this.pdfScribeBytes), name: ' State Biometric Privacy Laws' });
				}
				const response = await firstValueFrom(
				this.http.get(this.consentPdfUrl('Notice_of_Privacy_Practices_IL_v2-2.pdf'), {
					responseType: 'arraybuffer'
				}));
				const noppPdfBytes =  new Uint8Array(response);
				consentPdfs.push({ bytes: noppPdfBytes, name: 'NOPP' });
			}

			this.mergedConsentPdfSrc = await this.signaturePdfService.mergeConsentPDFs(consentPdfs);
		} catch (error) {
			console.error('Error rendering merged consent forms:', error);
		} finally {
			this.loadingService.hide();
		}
	}

	async goToConsentForms(): Promise<void> {
		const consentTab = document.getElementById("consent-forms-tab");
		if (consentTab) {
			consentTab.click();
		}
		await this.renderMergedConsentForms();
	}

	goBackFromConsentForms(): void {
		if (this.showPITab) {
			const piTab = document.getElementById("pi-tab");
			if (piTab) piTab.click();
		} else if (this.getABNTab) {
			const abnTab = document.getElementById("abn-tab");
			if (abnTab) {
				abnTab.click();
			}
		} else {
			this.goToIntakeForm();
		}
	}

	goNext() {
		this.showTabs();
		if (this.getABNTab) {
			// Go to ABN tab if Medicare patient
			const abnTab = document.getElementById("abn-tab");
			if (abnTab) {
				abnTab.click();
			}
		} else if (this.showPITab) {
			// Go to PI tab if MVA patient
			const piTab = document.getElementById("pi-tab");
			if (piTab) piTab.click();
			this.renderPIForm();
		} else {
			// Go directly to Consent Forms tab (consolidated)
			this.goToConsentForms();
		}
	}
	showDownloadDropdown() {
		this.availableForms = [];
		this.addDownloadIntakeForm(); // this should be displayed even if the form is not submitted yet
		if (!this.formData.data.consentOfPrivacyInformedAA) {
			return;
		}
		if (this.formData?.data?.abnNestedForm?.data) {
			this.addDownloadABN();
		}
		if (this.formData?.data?.isPatinetCoveredByInsurance === 'Automobile (Motor Vehicle Accident ONLY)') {
			this.addDownloadPI();
		}
		// Add merged consent forms as a single entry (includes all consent PDFs based on IsNewConsent flag)
		this.addDownloadConsentForms();
	}

		// Add merged consent forms as a single entry
	
	async addDownloadConsentForms() {
		// Check if consent forms are available
		if (
			this.formData.data.patientSignature &&
			this.formData.data.date2 &&
			!this.availableForms.some((x) => x.name === "Consent-Forms")
		) {
			this.availableForms.push({
				name: "Consent-Forms",
				formId: "",
				submissionId: "",
			});
		}
	}
	
	async addDownloadPI() {
		if (
			!this.availableForms.some((x) => x.name === "Personal-Injury-Consent-Form") &&
			this.formData?.data?.patientSignature &&
			this.formData?.data?.date2 &&
			this.formData?.data?.IsPersonalInjury === true
		) {
			this.availableForms.push({
				name: "Personal-Injury-Consent-Form",
				formId: "",
				submissionId: "",
			});
		}
	}

	showTabs() {
		if (!this.formData.data.consentOfPrivacyInformedAA) {
			return;
		}
		const tabs = ["Intake-Form"];
		if (this.getABNTab) {
			this.tabs[TabEnum.ABN].visible = true;
			tabs.push("ABN-Form");
		} else {
			this.tabs[TabEnum.ABN].visible = false;
		}
		if (this.showPITab) {
			this.tabs[TabEnum.PITemplate].visible = true;
			tabs.push("PI-Form");
		} else {
			this.tabs[TabEnum.PITemplate].visible = false;
		}
		tabs.push("Consent-Forms");
		this.availableTabs = tabs;
		this.addDownloadIntakeForm();
	}
	goToIntakeForm(): void {
		const pdfTab = document.getElementById("formio-tab");
		if (pdfTab) {
			pdfTab.click();
		}
	}
	private async renderExistingForm(container: HTMLElement, schema: any, readOnly: boolean) {
		// Create the form with appropriate options
		Formio.createForm(container, schema, {
			display: "wizard",
			readOnly: readOnly,
		}).then((form: any) => {
			this.form = form;
			// Store token
			if (this.token) {
				localStorage.setItem("formioToken", this.token);
			}
			form.on("error", (err: any) => {
				console.error("Form error:", err);
			});

			// Set submission data
			form.submission = this.formData;

			const imageFields = [
				{
					data: this.formData.data.licenseUploadFront,
					key: "licenseUploadFront",
					parent: this.formData.data,
				},
				{
					data: this.formData.data.container4?.secondarylicenseUploadFront,
					key: "secondarylicenseUploadFront",
					parent: this.formData.data.container4,
				},
				{
					data: this.formData.data.container4?.secondarylicenseUploadBack,
					key: "secondarylicenseUploadBack",
					parent: this.formData.data.container4,
				},
				{
					data: this.formData.data.container6?.fileUploadFront,
					key: "fileUploadFront",
					parent: this.formData.data.container6,
				},
				{
					data: this.formData.data.container6?.fileUploadBack,
					key: "fileUploadBack",
					parent: this.formData.data.container6,
				},
				{
					data: this.formData.data.uploadYourAutoInsurance,
					key: "uploadYourAutoInsurance",
					parent: this.formData.data,
				},
			];

			this.fileUploadService.refreshTokens(imageFields);
			// Only update the lockedBy field if we're in edit mode, not locked by another user,
			// and lockedBy isn't already set
			if (
				!readOnly &&
				!this.isLockedByOtherUser &&
				(!form.submission.data.lockedBy || form.submission.data.lockedBy === "")
			) {
				const userData = this.authService.getUserData();
				if (userData && userData.firstName) {
					form.submission.data.lockedBy = userData.firstName + " " + userData.lastName;
				}
			}
			// If not read-only, disable certain fields
			if (!readOnly) {
				const selectComponent = form.getComponent("selectChiroCenter");
				if (selectComponent) {
					selectComponent.component.disabled = true;
					form.redraw();
				}
			}
			this.applyPanelLogic(form);
			this.changeConsentLabel(form);
			this.changePILabel(form);
			this.changeWCLabel(form);

			if (!readOnly) {
				this.startAutosave(form);

				form.on("draftClicked", async () => {
					if (!this.validateSubscriberFields()) return;
					
					this.loadingService.show();
					this.resetMessages();
					await this.commitOpenGridRows();

					form.submission.data.localStatus = "Intake Form-Submitted";
					const userData = this.authService.getUserData();
					if (userData && userData.firstName) {
						form.submission.data.updatedBy = userData.firstName + " " + userData.lastName;
					}

					await this.beginManualSave();
					const canSave = await this.checkLockAndConflictsBeforeSave();
					if (!canSave) {
						this.endManualSave();
						this.loadingService.hide();
						return;
					}
					this._showAATab = true;
					this._showInformedConsentTab = true;
					this.tabs[TabEnum.CommunicationsConsent].visible = true;
					this._showTextConsentTab = true;

					if (this.showInformedConsentTab && this.showAATab){
						if (this.formData.data.IsNewConsent) {
							await this.renderInformedConsentNew();
							await this.renderNOPPTab();
							await this.renderAATabNew();
						} else {
							await this.renderInformedConsent();
							await this.renderAATab();
						}
					}
					
					this.patientService
						.updateSubmission(this.submissionId!, form.submission)
						.then(async (response) => {
							await this.saveFormSnapshot();
							if (this.formData.data.IsNewConsent) {
								await this.saveAASnapshotNew();
								await this.saveInformedConsentSnapshotNew();
								await this.saveNOPPSnapshot();
							} else {
								await this.saveAASnapshot();
								await this.saveInformedConsentSnapshot();
								await this.saveTextConsentSnapshot();
								await this.saveCCOFSnapshot();
								
							}
							await this.saveScribeSnapshot();
							if (this.showPITab) {
								await this.savePISnapshot();
							}
							await this.showDownloadDropdown();
							await this.sendInsuranceImagesIfChanged();
							this.formData.data.patientInformedConsentForm =
								response.submission.data.patientInformedConsentForm;
							this.formData.data.agreementsAuthorizations =
								response.submission.data.agreementsAuthorizations;
							// Whole submission just went to the server, nothing is pending
							// This is now the copy we work from
							this.autosave.rebaseline(form.submission?.data);
							this.captureServerFingerprint(response.submission);
							this.showMessage("Form saved successfully");
							this.showTabs();
							this.loadingService.hide();
						})
						.catch((error: any) => {
							console.error("Submission update error:", error);
							this.showError(`Failed to update submission: ${error.message || "Unknown error"}`);
							this.loadingService.hide();
						})
						.finally(() => this.endManualSave());
				});
			}

			// Customize buttons on render
			form.on("render", () => {
				this.attachCardClickListeners(form);
				// this.showDownloadDropdown();
				//show button after render. Looks ugly on first page load
				this.firstLoad = false;

				const nextButton = Array.from(document.querySelectorAll("button")).filter(
					(button) => button?.textContent?.trim().toLowerCase() === "submit form"
				);

				nextButton[0].style.display = "none";

				const cancelButton = Array.from(document.querySelectorAll("button")).filter(
					(button) => button?.textContent?.trim().toLowerCase() === "cancel"
				);

				cancelButton[0].style.display = "none";

				this.skipClearButtonsOnTab();
				this.enableEnterOnCheckboxes();
				this.attachAddRowGuards(form);
			});
		});
	}

	private enableEnterOnCheckboxes() {
		if (this.enterCheckboxHandler) return;

		this.enterCheckboxHandler = (e: KeyboardEvent) => {
			if (e.key !== 'Enter') return;
			const target = e.target as HTMLInputElement | null;
			if (target?.tagName === 'INPUT' && target.type === 'checkbox') {
				e.preventDefault();
				target.click();
			}
		};

		document.addEventListener('keydown', this.enterCheckboxHandler);
	}

	private skipClearButtonsOnTab() {
		// Remove non-input UI controls from the tab order so users tab straight
		const SKIP_SELECTOR =
			'.choices__button, [ref="tooltip"], .bi-question-circle-fill, .fa-question-circle';

		const apply = (root: ParentNode) => {
			root.querySelectorAll<HTMLElement>(SKIP_SELECTOR).forEach((el) => {
				if (el.getAttribute('tabindex') !== '-1') {
					el.setAttribute('tabindex', '-1');
				}
			});
		};

		apply(document);

		if (this.clearButtonObserver) return;

		this.clearButtonObserver = new MutationObserver((mutations) => {
			for (const m of mutations) {
				m.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return;
					if (node.matches?.(SKIP_SELECTOR)) {
						node.setAttribute('tabindex', '-1');
					}
					apply(node);
				});
			}
		});

		this.clearButtonObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	// The PI checkbox label is hardcoded in Form.io, so its link is rewritten here
	// The component is conditional on MVA insurance, so it is not always present
	changePILabel(form: any) {
		const checkboxComp = form.getComponent('IsPersonalInjury');
		if (!checkboxComp?.component) return;
		checkboxComp.component.label =
			`I have reviewed and accept <a target='_blank' href='${this.consentPdfUrl(PI_CONSENT_PDF)}'> Personal Injury Authorization, Assignment, Contractual Lien & Letter of Protection.</a> <span style='color:red'>*</span>`;
	}

	// Same for the workers comp download note, conditional on WC insurance
	changeWCLabel(form: any) {
		const infoComp = form.getComponent('infoForWorkersComp');
		if (!infoComp?.component) return;
		infoComp.component.information =
			`Please download these additional  <a href="${this.consentPdfUrl(WC_FORMS_PDF)}" target="_blank">Workers Compensation Forms</a>  and bring them completed along with and a copy of your accident report when you arrive for your appointment.`;
	}

	 changeConsentLabel(form:any){
		const checkboxComp = form.getComponent('consentOfPrivacyInformedAA');
		const linkClass = 'consent-link';
		// Picks branded or Alaska per file
		const pdf = (fileName: string) => this.consentPdfUrl(fileName);
		if ((this.formData.data.IsNewConsent === this.formData.data.consentOfPrivacyInformedAA) ||
			(this.formData.data.IsNewConsent === undefined && this.formData.data.consentOfPrivacyInformedAA === false)){
			checkboxComp.component.label = ` I have reviewed and accept <a class="${linkClass}" target="_blank" href="${pdf('Patient Informed Consent v3-2026-01-08.pdf')}"> Patient Informed Consent Form</a>, <a class="${linkClass}" target="_blank" href="${pdf('Payment Agreement and Authorization v3-2026-01-08.pdf')}">Payment Agreements & Authorizations</a>, `;
			if ((this.formData.data?.consentOfPrivacyInformedAA === this.formData.data?.IsScribeConsent)
				|| (this.formData.data?.consentOfPrivacyInformedAA === false && this.formData.data.IsScribeConsent === undefined)
			) {
				if (this.formData.data?.IsNewScribeConsent || !this.formData.data?.consentOfPrivacyInformedAA) {
					checkboxComp.component.label +=` <a class="${linkClass}" target="_blank" href="${pdf('State Biometric Privacy Laws Disclosure and Consent New.pdf')}">State Biometric Privacy Laws Disclosure and Consent</a>, `;
				} else {
					checkboxComp.component.label +=` <a class="${linkClass}" target="_blank" href="${pdf('State Biometric Privacy Laws Disclosure and Consent.pdf')}">State Biometric Privacy Laws Disclosure and Consent</a>, `;
				}
			}
			checkboxComp.component.label += ` <a class="${linkClass}" target="_blank" href="${pdf('Acknowledgement of Receipt of NOPP v1-2026-01-08.pdf')}">Acknowledgement of Receipt of Notice of Privacy Practices</a>, and <a class="${linkClass}" target="_blank" href="${pdf('Notice of Privacy Practices v2-2026-01-08.pdf')}"> Notice of Privacy Practices</a>`;
		}
		else {
			if ((this.formData.data?.consentOfPrivacyInformedAA === this.formData.data?.IsScribeConsent)
				|| (this.formData.data?.consentOfPrivacyInformedAA === false && this.formData.data.IsScribeConsent === undefined)
			) {
				if (this.formData.data?.IsNewScribeConsent || !this.formData.data?.consentOfPrivacyInformedAA) {
					checkboxComp.component.label +=` <a class="${linkClass}" target="_blank" href="${pdf('State Biometric Privacy Laws Disclosure and Consent New.pdf')}">State Biometric Privacy Laws Disclosure and Consent</a>, `;
				} else {
					checkboxComp.component.label +=` <a class="${linkClass}" target="_blank" href="${pdf('State Biometric Privacy Laws Disclosure and Consent.pdf')}">State Biometric Privacy Laws Disclosure and Consent</a>, `;
				}
			}
			if ((this.formData.data?.consentOfPrivacyInformedAA === this.formData.data?.IsTextConsentInformed)
			 || (this.formData.data?.consentOfPrivacyInformedAA === false && this.formData.data.IsTextConsentInformed === undefined)
			) {
				checkboxComp.component.label +=`, <a class="${linkClass}" target="_blank" href="${pdf('Communications Consent Form v1.0.pdf')}"> Communications Consent Form</a>`;
			}
			if ((this.formData.data?.consentOfPrivacyInformedAA === this.formData.data?.IsCCOFConsent)
				|| (this.formData.data?.consentOfPrivacyInformedAA === false && this.formData.data.IsCCOFConsent === undefined)
				) {
				checkboxComp.component.label +=`, <a class="${linkClass}" target="_blank" href="${pdf('Credit Card On File (CCOF) v1.0.pdf')}"> Credit Card On File Consent Form.</a>`;
			}
		}
		 checkboxComp.component.label += ` <span style="color:red">*</span>`
	}
	applyPanelLogic(form: any) {
		const componentsArray = form.root.getComponents();
		if (!componentsArray || !componentsArray.length) return;
		const components = componentsArray[0].components;

		components.forEach((component: any, index: any) => {
			if (component.component.type !== "customPanel") return;

			// Make panel collapsible
			component.component.collapsible = true;
			component.collapsed = index !== 0;
			// Set coloring / completed state based on your data
			if (
				component.checkValidity() &&
				(this.formData.data.localStatus === "Intake Form-In Process" ||
					this.formData.data.localStatus === "Intake Form-Submitted")
			) {
				component.component.headerCSS = "custom-panel-sucess";
				component.component.stepNumberCSS = "step-number-sucess";
				component.component.isCompleted = "true";
				component.disabled = false;
			} else if (this.formData.data.localStatus === "Appointment-Booked") {
				component.disabled = false;
			}
		});

		form.redraw();
	}
	attachCardClickListeners(form: any) {
		const componentsArray = form.root.getComponents();
		if (!componentsArray?.length) return;

		const components = componentsArray[0].components;
		components.forEach((component: any, index: number) => {
			if (component.component.type !== "customPanel") return;

			const headerEl = component.refs?.header;
			if (headerEl) {
				headerEl.addEventListener("click", () => this.onCardClick(index, form));
			}
		});
	}
	// Section 10 (Additional Clinical Comments) is allowed to stay open AT THE SAME TIME as one other section
	// opening it does not collapse the others
	// opening another section does not collapse it
	// All other sections keep the "only 1 open" behavior
	private isClinicalCommentsPanel(comp: any): boolean {
		return comp?.component?.key === "clinicalComments";
	}

	onCardClick(index: number, form: any) {
		const components = form.root.components[0]?.components;
		if (!components) return;

		//this is a logic after the collapse/expansion already happens
		const clicked = components[index];
		if (clicked.collapsed) {
			return;
		}

		// Section 10 was opened -> keep it open, don't touch the other sections
		if (this.isClinicalCommentsPanel(clicked)) {
			return;
		}

		// Another section was opened -> collapse all EXCEPT the clicked one 
		// and EXCEPT Section 10 (Section 10 keeps its current state)
		components.forEach((comp: any, i: number) => {
			if (i === index) {
				comp.collapsed = false;
				return;
			}
			if (this.isClinicalCommentsPanel(comp)) {
				return;
			}
			comp.collapsed = true;
		});
		form.redraw();
	}

	async triggerCancel(event: Event, readOnly: boolean) {
		event.preventDefault();
		if (!confirm("Are you sure you want to cancel? This action will unlock the form.")) {
			return;
		}

		// If we're in edit mode, unlock the submission before navigating away
		if (!readOnly && !this.isLockedByOtherUser && this.submissionId) {
			await this.unlockSubmissionBeforeLeaving();
		}
		this.router.navigate(["/patients"]);
	}
	takeOverOwnForm(){
		if(!this.submissionId)
			return;
		if(!this.isOpenInAnotherTab || !this.isReadOnly){
			return;
		}

		// set flag to prevent unlock from triggering during reload
		this.isTakingOver = true;

		// force release the old tab's lock from localStorage so the reload won't detect "open in another tab" again
		this.tabTrackingService.forceReleaseLock(this.submissionId);

		// register this tab as the new lock owner
		const currentUser = this.authService.getUserData();
		const currentUserId = currentUser?._id;
		if (currentUserId) {
			this.tabTrackingService.registerLock(this.submissionId, currentUserId);
		}

		// old tab save check will detect the takeover
		localStorage.setItem(`activeTabId_${this.submissionId}`, this.tabInstanceId);

		this.isOpenInAnotherTab = false;
		this.readingMode = false;
		this.isReadOnly = false;

		// reload the page without the mode=readonly query param
		const url = `${window.location.origin}/#/new-intake/${this.submissionId}`;
		window.location.href = url;
		window.location.reload();
	}

	async takeOverForm(){
		if(!this.submissionId)
			return;

		if (!this.isLockedByOtherUser || this.isOpenInAnotherTab || this.readingMode)
			return;

		// Confirm the user wants to take over the form
		if (!confirm(`Are you sure you want to take over this form? This will unlock it from ${this.lockedByUser} and allow you to edit it.`)) {
			return;
		}

		try {
			this.loadingService.show();

			// set flag to prevent unlock during reload
			this.isTakingOver = true;

			await this.patientService.unlockSubmission(this.submissionId, true);

			// clear any stale locks and register this tab
			const currentUser = this.authService.getUserData();
			const currentUserId = currentUser?._id;
			this.tabTrackingService.forceReleaseLock(this.submissionId);
			if (currentUserId) {
				this.tabTrackingService.registerLock(this.submissionId, currentUserId);
			}

			localStorage.setItem(`activeTabId_${this.submissionId}`, this.tabInstanceId);

			this.isLockedByOtherUser = false;

			this.showMessage('Form unlocked successfully. Reloading in edit mode...');

			setTimeout(() => {
				window.location.reload();
			}, 1000);

		} catch (error: any) {
			this.isTakingOver = false;
			console.error('Error taking over form:', error);
			this.showError(`Failed to unlock form: ${error.message || 'Unknown error'}`);
		} finally {
			this.loadingService.hide();
		}
	}
	// Method to unlock submission after form is submitted successfully
	private async unlockSubmissionAfterSubmit() {
		try {
			if (this.submissionId) {
				// Only attempt to unlock if:
				// 1. We're not in read-only mode
				// 2. Not open in another tab by this user
				if (!this.isReadOnly && !this.isOpenInAnotherTab) {
					// First, release the lock in our tab tracking
					this.tabTrackingService.releaseLock(this.submissionId);

					try {
						// Use force=true to bypass the ownership check on submission
						// This is critical as the current user might not be the original locker
						await this.patientService.unlockSubmission(this.submissionId, true);
					} catch (unlockError: any) {
						console.warn(`Error during forced unlock after submission: ${unlockError.message}`);
						// Continue with form submission process even if unlock fails
					}
				}
			}
		} catch (error: any) {
			console.error("Error in unlock after submit process:", error);
			// Log error but don't block submission process
		}
	}

	// Method to unlock submission when navigating away (cancel button)
	private async unlockSubmissionBeforeLeaving() {
		try {
			if (this.submissionId) {
				// Only attempt to unlock if:
				// 1. We're not in read-only mode
				// 2. Not locked by another user
				// 3. Not open in another tab by this user
				if (!this.isReadOnly && !this.isLockedByOtherUser && !this.isOpenInAnotherTab) {
					// First, release the lock in our tab tracking
					this.tabTrackingService.releaseLock(this.submissionId);

					try {
						// Also add force=true here for consistency and to avoid 403 errors
						await this.patientService.unlockSubmission(this.submissionId, true);
					} catch (error: any) {
						console.error("Error during unlock before leaving:", error);
						// Don't block navigation even if unlock fails
					}
				}
			}
		} catch (error: any) {
			console.error("Error in unlockSubmissionBeforeLeaving process:", error);

			// Show an alert for lock ownership errors but don't block navigation
			if (error.isLockOwnershipError) {
				this.showError(`Cannot unlock: ${error.message}`);
			}

			// Don't block navigation even if unlock fails
		}
	}
	/**
	 * Clean up form when no longer needed
	 */
	private destroyForm() {
		if (this.form) {
			this.form.destroy();
			this.form = null;
		}
	}

	// Update the ngOnDestroy method to release tab locks
	ngOnDestroy() {
		// Flush what is pending, then stop, the service is a root singleton
		this.autosave.flushOnUnload();
		this.autosave.stop();
		this.autosaveSub?.unsubscribe();

		// Clean up subscriptions
		if (this.routeSub) {
			this.routeSub.unsubscribe();
		}

		// Clean up storage event listener
		if (this.storageListener) {
			window.removeEventListener('storage', this.storageListener);
			this.storageListener = null;
		}

		if (this.clearButtonObserver) {
			this.clearButtonObserver.disconnect();
			this.clearButtonObserver = undefined;
		}

		if (this.enterCheckboxHandler) {
			document.removeEventListener('keydown', this.enterCheckboxHandler);
			this.enterCheckboxHandler = undefined;
		}

		// don't unlock if the form was successfully submitted (already unlocked)
		// don't unlock if another tab took over (they own the lock now)
		// don't unlock during a takeover reload
		if (!this.formSubmitted && !this.formTakenOver && !this.isTakingOver) {
			// Release any locks owned by this tab
			if (
				this.submissionId &&
				!this.isReadOnly &&
				!this.isLockedByOtherUser &&
				!this.isOpenInAnotherTab
			) {
				this.tabTrackingService.releaseLock(this.submissionId);

				// Also unlock in the backend
				this.unlockSubmissionBeforeLeaving();
			}
		}

		// Destroy form
		this.destroyForm();
	}

	// Commit any unsaved EditGrid / DataGrid rows that the user left in "edit" or "new" state before submitting the form.
	// medication list, supplement list, motor-vehicle accident list, additional concerns
	
	private async commitOpenGridRows(): Promise<void> {
		const saved = await this.saveAllOpenEditGridRows();
		if (saved > 0) {
			await new Promise((resolve) => setTimeout(resolve, 200));
		}
	}

	// Data with filled but uncommitted grid rows folded in
	// FormIO keeps an open row out of submission.data until it is committed
	// Committing it here would close the row being typed in, so we copy instead
	// Empty placeholder rows are dropped, same as the explicit Save
	private dataWithOpenGridRows(): any {
		const data = this.form?.submission?.data;
		if (!data) return data;

		const form = this.form;
		if (typeof form.everyComponent !== "function") return data;

		let augmented: any = null;

		try {
			form.everyComponent((comp: any) => {
				if (!comp || !comp.component) return;
				const type = comp.component.type;
				if (type !== "editgrid" && type !== "datagrid") return;
				// Skip grids that are conditionally hidden (user answered No)
				if (comp.visible === false) return;

				const path = comp.path || comp.component.key;
				// Nested grid path has an index, not safe to write, left to the explicit Save
				if (!path || path.includes("[")) return;

				const editRows: any[] = comp.editRows || [];
				if (editRows.length === 0) return;

				const rows: any[] = [];
				let hasOpenRow = false;

				for (const row of editRows) {
					if (!row) continue;

					if (row.state === "saved") {
						rows.push(row.data);
						continue;
					}

					if (row.state !== "new" && row.state !== "editing") continue;
					if (!this.isRowTouched(row)) continue;

					rows.push(row.data);
					hasOpenRow = true;
				}

				// Nothing uncommitted, so the data is already correct
				if (!hasOpenRow) return;

				augmented = augmented ?? JSON.parse(JSON.stringify(data));
				this.setValueAtPath(augmented, path, JSON.parse(JSON.stringify(rows)));
			});
		} catch (err) {
			console.warn("[autosave] could not fold open grid rows into the data:", err);
			return data;
		}

		return augmented ?? data;
	}

	private setValueAtPath(target: any, path: string, value: any): void {
		const segments = path.split(".");

		let node = target;
		for (let i = 0; i < segments.length - 1; i++) {
			const segment = segments[i];
			if (typeof node[segment] !== "object" || node[segment] === null) {
				node[segment] = {};
			}
			node = node[segment];
		}

		node[segments[segments.length - 1]] = value;
	}

	// Wrap every EditGrid's addRow so clicking "Add Another X" cannot leave two
	// open rows in the same grid. If a previous row is open + filled, auto-save it.
	// If it's open + empty, block the new row entirely.
	private attachAddRowGuards(form: any) {
		if (!form || typeof form.everyComponent !== "function") return;
		form.everyComponent((comp: any) => {
			if (!comp || !comp.component) return;
			if (comp.component.type !== "editgrid") return;
			if ((comp as any).__addRowGuarded) return;
			if (typeof comp.addRow !== "function") return;

			(comp as any).__addRowGuarded = true;
			const gridKey = comp.component?.key || "(unknown)";
			const originalAddRow = comp.addRow.bind(comp);

			comp.addRow = (...args: any[]) => {
				const editRows: any[] = comp.editRows || [];
				for (let i = 0; i < editRows.length; i++) {
					const row = editRows[i];
					if (!row) continue;
					if (row.state !== "new" && row.state !== "editing") continue;

					if (!this.isRowTouched(row)) {
						console.log(
							`[editgrid:${gridKey}] addRow blocked: empty open row at index ${i}`,
						);
						return undefined;
					}

					// filled — auto-save before opening a new row
					try {
						comp.saveRow(i, true);
					} catch (err) {
						console.warn(`[editgrid:${gridKey}] saveRow failed:`, err);
					}

					// if still open after save attempt, block (validation failed)
					if (row.state === "new" || row.state === "editing") {
						console.log(
							`[editgrid:${gridKey}] addRow blocked: row ${i} did not save (validation?)`,
						);
						return undefined;
					}
				}

				return originalAddRow(...args);
			};
		});
	}

	// True when the user actually interacted with this row's fields
	private isRowTouched(row: any): boolean {
		if (!row) return false;
		if (this.anyDescendantTouched(row)) return true;
		return !this.isDataShapeEmpty(row.data);
	}

	private anyDescendantTouched(obj: any): boolean {
		if (!obj || typeof obj !== "object") return false;
		if (obj.pristine === false) return true;
		if (obj.dirty === true) return true;
		if (obj.isModified === true) return true;

		const kids: any[] = Array.isArray(obj.components)
			? obj.components
			: obj.components && typeof obj.components === "object"
				? Object.values(obj.components)
				: [];

		for (const k of kids) {
			if (this.anyDescendantTouched(k)) return true;
		}
		return false;
	}

	// true if the data object holds no meaningful (non-default) values
	private isDataShapeEmpty(rowData: any): boolean {
		if (rowData === null || rowData === undefined) return true;
		if (typeof rowData !== "object") {
			return rowData === "" || rowData === false;
		}
		for (const key in rowData) {
			const v = rowData[key];
			if (v === null || v === undefined || v === "" || v === false) continue;
			if (Array.isArray(v) && v.length === 0) continue;
			if (typeof v === "object") {
				if (!this.isDataShapeEmpty(v)) return false;
				continue;
			}
			return false;
		}
		return true;
	}

	// Goes through ervery component in the form and commits any open rows in every EditGrid / DataGrid
	private async saveAllOpenEditGridRows(): Promise<number> {
		const form = this.form;
		if (!form || typeof form.everyComponent !== "function") return 0;

		const grids: any[] = [];
		try {
			form.everyComponent((comp: any) => {
				if (!comp || !comp.component) return;
				const type = comp.component.type;
				if (type !== "editgrid" && type !== "datagrid") return;
				// Skip grids that are conditionally hidden (user answered No)
				if (comp.visible === false) return;
				grids.push(comp);
			});
		} catch (err) {
			console.warn("[commitOpenGridRows] everyComponent walk failed:", err);
			return 0;
		}

		console.log(`[commitOpenGridRows] inspecting ${grids.length} grid(s)`);

		let savedCount = 0;
		for (const grid of grids) {
			const gridKey = grid.component?.key || grid.key || "(unknown grid)";
			const editRows: any[] = grid.editRows || [];

			// drop the empty placeholder rows
			for (let i = editRows.length - 1; i >= 0; i--) {
				const row = editRows[i];
				if (!row) continue;
				const state = row.state;
				if (state !== "new" && state !== "editing") continue;
				if (this.isRowTouched(row)) continue;

				console.log(
					`[commitOpenGridRows] grid '${gridKey}' row ${i} empty -> cancel`,
					row.data,
				);
				try {
					if (typeof grid.cancelRow === "function") grid.cancelRow(i);
				} catch (err) {
					console.warn(
						`[commitOpenGridRows] cancelRow failed for grid '${gridKey}' row ${i}:`,
						err,
					);
				}
			}

			//  commit the rows the user filled in
			const remaining: any[] = grid.editRows || [];
			const newDataValue: any[] = [];
			let touchedAny = false;

			for (let i = 0; i < remaining.length; i++) {
				const row = remaining[i];
				if (!row) continue;
				const state = row.state;

				if (state === "saved") {
					// Already committed row, keep its existing data
					newDataValue.push(row.data);
					continue;
				}

				if (state !== "new" && state !== "editing") continue;

				// Filled but uncommitted, save it
				console.log(
					`[commitOpenGridRows] grid '${gridKey}' row ${i} state='${state}' -> commit`,
					row.data,
				);
				newDataValue.push(row.data);
				row.state = "saved";
				row.isOpen = false;
				touchedAny = true;
				savedCount++;
			}

			if (touchedAny) {
				try {
					if (typeof grid.setValue === "function") {
						grid.setValue(newDataValue, { modified: true });
					} else {
						grid.dataValue = newDataValue;
					}
				} catch (err) {
					console.warn(
						`[commitOpenGridRows] setValue failed for grid '${gridKey}':`,
						err,
					);
					try {
						grid.dataValue = newDataValue;
					} catch {
						/* ignore */
					}
				}
			}
		}

		if (savedCount > 0) {
			try {
				form.triggerChange?.({ modified: true });
			} catch {
				// best-effort
			}
		}

		console.log(`[commitOpenGridRows] committed ${savedCount} row(s)`);
		return savedCount;
	}
}
//QA branch
